import React, { useEffect, useRef, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import thanedarImg from "../../images/candidates/Shri Thanedar.jpg";
import raja from "../../images/candidates/Raja Krishnamoorthi.jpg";
import suhas from "../../images/candidates/suhas.jpg";
import gerry from "../../images/candidates/gerry.jpg";
import George from "../../images/candidates/George Latimer.jpg";
import Gregory from "../../images/candidates/Gregory Meeks.jpg";
import mike from "../../images/candidates/mike lawler.jpg";
import pat from "../../images/candidates/pat fallon.jpg";
import michaelwebber from "../../images/candidates/Michael Gates.jpg";
import tomkuhn from "../../images/candidates/Tom Kuhn.png";
import vin from "../../images/candidates/vin kruttiventi.jpg";
import scott from "../../images/candidates/scott baugh.jpg";
import evan from "../../images/candidates/evan low.jpg";
import seemakanani from "../../images/candidates/Seema Kanani .png";
import troy from "../../images/candidates/troy nehls.jpg";
import santoshrao from "../../images/candidates/Santosh Rao.jpg";
import webber from "../../images/candidates/webber-michael.jpg";
import rich from "../../images/candidates/rich mccormic.jpg";
import darrell from "../../images/candidates/darrell issa.jpg";
import kim from "../../images/candidates/young kim.jpg";
import michelle from "../../images/candidates/michelle steel.jpg";
import linda from "../../images/candidates/linda sanchez.jpg";
import patrick from "../../images/candidates/patrick ahrens.jpg";
import steven from "../../images/candidates/steven choi.jpg";
import kristie from "../../images/candidates/kristie bruce.jpg";
import san from "../../images/candidates/sangeetha shanbhogue.jpg";
import rinu from "../../images/candidates/rinu nair.jpg";
import vivek from "../../images/candidates/vivek prasad.jpg";
import vivek2 from "../../images/candidates/Vivek Ramaswamy.jpg";
import long from "../../images/candidates/long jiao.jpg";
import lee from "../../images/candidates/aegean lee.jpg";
import sharma from "../../images/candidates/lakshmi sharma.jpg";
import lydia from "../../images/candidates/lydia kou.jpg";
import zeel from "../../images/candidates/zeel ahir.jpg";
import vikesh from "../../images/candidates/vikesh patel.jpg";
import neel from "../../images/candidates/neel patel.jpg";
import timmy from "../../images/candidates/timmy kim.jpg";
import GregoryMeeks from "../../images/press-releases/Gregory W Meeks.jpg";
import schneider from "../../images/candidates/brad schneider.jpg";
import sherman from "../../images/candidates/brad sherman.jpg";
import buddy from "../../images/candidates/buddy carter.jpg";
import gopalkurappan from "../../images/candidates/Gopal-Kumarappan.png";
import danny from "../../images/candidates/danny k davis.jpg";
import dutch from "../../images/candidates/dutch ruppersberger.jpg";
import earl from "../../images/candidates/earl blumenauer.jpg";
import eleanor from "../../images/candidates/eleanor holmes norton.jpg";
import frank from "../../images/candidates/frank pallone.jpg";
import glenn from "../../images/candidates/glenn lvey.jpg";
import haley from "../../images/candidates/haley stevens.jpg";
import jared from "../../images/candidates/jared moskowitz.jpg";
import jarry from "../../images/candidates/jarry nadler.jpg";
import joe from "../../images/candidates/joe neguse.jpg";
import Jenne from "../../images/candidates/Jenne Alderks.png";
import kathy from "../../images/candidates/Kathy Watanabe.png";
import juan from "../../images/candidates/juan vargas.jpg";
import shivraj from "../../images/candidates/Shivraj Singh.png";
import Ilanit from "../../images/candidates/Ilanit Eliaz.png";
import Melinda from "../../images/candidates/Melinda Liu.png";
import Sonia from "../../images/candidates/Sonia Salwan.png";
import judy from "../../images/candidates/judy chu.jpg";
import kevin from "../../images/candidates/kevin mullin.jpg";
import lloyd from "../../images/candidates/lloyd doggett.jpg";
import marcy from "../../images/candidates/marcy kaptur.jpg";
import ritchie from "../../images/candidates/ritchie torres.jpg";
import sanford from "../../images/candidates/sanford bishop.jpg";
import steve from "../../images/candidates/steve cohen.jpg";
import andrewfriedson from "../../images/candidates/Andrew Friedson.png";
import ethan from "../../images/candidates/ethan agarwal.jpg";
import gopal from "../../images/candidates/Gopal Krishan.jpg";
import lynette from "../../images/candidates/Lynette Lee Eng .jpg";
import madison from "../../images/candidates/Madison Nguyen.jpg";
import pamela from "../../images/candidates/Pamela Price.jpg";
import kitty from "../../images/candidates/Kitty Moore.jpg";
import ray from "../../images/candidates/Ray Wang.jpg";
import Richa from "../../images/candidates/Richa Awasthi .jpg"
import Raj from "../../images/candidates/Raj Salwan.jpg"
import teresa from "../../images/candidates/Teresa Keng.jpg"
import chandrashekhar from "../../images/candidates/Chandrashekhar Wagh.jpg"
import teresacox from "../../images/candidates/Teresa Cox .jpg"
import lily from "../../images/candidates/Lily Mei Mayor .jpg"
import yang from "../../images/candidates/Yang Shao.jpg"
import dipak from "../../images/candidates/Dipak Awasthi.jpg"
import hon from "../../images/candidates/Hon Lien.jpg"
import renu from "../../images/candidates/Renu Malhotra.jpg"
import domingo from "../../images/candidates/Domingo Candelas.jpg"
import arjun from "../../images/candidates/Arjun Batra.jpg"
import satish from "../../images/candidates/Satish Chandra Vale.jpg"
import lisa from "../../images/candidates/Lisa Gillmor.jpg"
import chirag from "../../images/candidates/Chirag Kathrani.jpg"
import vasanth from "../../images/candidates/Vasanth Shetty.jpg"
import larry from "../../images/candidates/Larry Klein.jpg"
import ashish from "../../images/candidates/Ashish Garg.jpg"
import rishi from "../../images/candidates/rishi kumar.jpg"
import anuj from "../../images/candidates/anuj dixit.jpg"
import bruce from "../../images/candidates/Bruce Leon.jpg"
import rakhi from "../../images/candidates/Rakhi Israni.jpg"
import randy from "../../images/candidates/Randy Fine.jpg"
import jimmy from "../../images/candidates/Jimmy Patronis.jpg"
import max from "../../images/candidates/Max Miller.jpg"
import james from "../../images/candidates/James McGovern.jpg"
import hank from "../../images/candidates/Hank Johnson.jpg"
import sheila from "../../images/candidates/Sheila Jackson Lee.jpg"
import cindy from "../../images/candidates/Cindy Hyde-Smith.jpg"
import devin from "../../images/candidates/Devin Nunes.jpg"
import rakesh from "../../images/candidates/Rakesh Ramakrishnan.jpg"
import piadan from "../../images/candidates/pia-dandiya.png"
import rosaura from "../../images/candidates/Rosaura Rosy.jpg"
import jim from "../../images/candidates/Jim Risch.jpg"
import andy from "../../images/candidates/Andy Barr.jpg"
import jason from "../../images/candidates/Jason Miyares.jpg"
import drrakeshramakrishnan from "../../images/candidates/Dr. Rakesh Ramakrishnan .png"
import geary from "../../images/candidates/Geary Higgins.jpg"
import aditya from "../../images/candidates/Aditya Ahlawat.jpg"
import jag from "../../images/candidates/Jag Nagendra.jpg"
import scotwiener from "../../images/candidates/Scott Wiener.jpg"
import billhuizenga from "../../images/candidates/Bill Huizenga.jpg"
import anilkumar from "../../images/candidates/Dr. Anil Kumar.jpg"
import benallen from "../../images/candidates/Ben Allen.jpg"
import maliacohen from "../../images/candidates/Malia Cohen.jpg"
import michaelgates from "../../images/candidates/Michael Gates.jpg"
import chinmay from "../../images/candidates/Chinmay Nagarkar.jpg"
import elenikounalakis from "../../images/candidates/Eleni Kounalakis.jpg"
import fionama from "../../images/candidates/Fiona Ma.jpg"
import joshnewman from "../../images/candidates/Josh Newman.jpg"
import donaldpwagner from "../../images/candidates/Donald P. Wagner.jpg"
import marcberman from "../../images/candidates/Marc Berman.jpg"
import davidcohen from "../../images/candidates/David Cohen.jpg"
import chiragrkathrani from "../../images/candidates/Chirag R. Kathrani.jpg"
import alexlee from "../../images/candidates/Alex Lee.jpg"
import ericlucan from "../../images/candidates/Eric Lucan.jpg"
import tracykosolcharoen from "../../images/candidates/Tracy_Headshot_v3.jpg"
import vipin2 from "../../images/candidates/vipin-profile.DuiYA9Ca.png"
import carolpefley from "../../images/candidates/Carol Pefley.jpg"
import gailpellerin from "../../images/candidates/Gail Pellerin.jpg"
import jayvaingankar from "../../images/candidates/Jay Vaingankar.jpg";
import johnpimentel from "../../images/candidates/John Pimentel.jpg";
import seliawarren from "../../images/candidates/Selia Warren.jpg";
import jeffrosen from "../../images/candidates/Jeff Rosen.jpg";
import neysafligor from "../../images/candidates/Neysa Fligor.jpg";
import kismat from "../../images/candidates/Kismat R. Kathrani.jpg";
import deepika from "../../images/candidates/Deepika Naharas.jpg";
import pratima from "../../images/candidates/Pratima Sonavane.jpg"; 
import rish from "../../images/candidates/Rish Rao.jpg";
import alysse from "../../images/candidates/Alysse Castro.jpg";
import hector from "../../images/candidates/Hector Marin.jpg";
import manisha from "../../images/candidates/Manisha Pathak.jpg";
import santosh from "../../images/candidates/Santosh Rao.jpg";
import theresarich from "../../images/candidates/Theresa Rich.jpg";
import murali from "../../images/candidates/Murali Srinivasan.jpg";
import jerry from "../../images/candidates/Jerry Nadler.jpg";
import ashok from "../../images/candidates/Ashok Baddi.jpg";
import ashokbaddi from "../../images/candidates/Ashok Baddi.jpg";
import kumar from "../../images/candidates/Dr. Anil Kumar.jpg";
import samliccardo from "../../images/candidates/Sam Liccardo.jpg";
import drprabuselvam from "../../images/candidates/Dr. Prabu Selvam.png";
import honglien from "../../images/candidates/Hong Lien.png";
import manishapathak from "../../images/candidates/Manisha Pathak.jpg";
import bridgetWatson from "../../images/candidates/Watson.jpg";
import gates from "../../images/candidates/Michael Gates.jpg";
import brettmartinez from "../../images/candidates/Brett Martinez.jpg";
import philweiser from "../../images/candidates/Phil Weiser.jpg";
import jasonlin from "../../images/candidates/jason lin.jpg";
import jasoncrow from "../../images/candidates/Jason Crow.jpg";
import julietesta from "../../images/candidates/julie testa.jpg";
import joshhoover from "../../images/candidates/Josh Hoover.jpg";
import darshanapatel from "../../images/candidates/Darshana Patel.jpg";
import daniellepenman2 from "../../images/candidates/Danielle Penman.jpg";
import paulsethy2 from "../../images/candidates/Paul Sethy.jpg";
import rod from "../../images/candidates/Rod Vilhauer.png";
import jhonlovick2 from "../../images/candidates/John-Lovick.jpg";
import shelleykloba2 from "../../images/candidates/shelley kloba.jpg";
import davinaduerr2 from "../../images/candidates/Davina-Duerr-2024.jpg";
import ronscolesdang2 from "../../images/candidates/rscolesdang.jpg";

import pia from "../../images/press-releases/Pia_Dandiya.jpg";
import eng from "../../images/press-releases/Lynette_Lee.jpg";
import tracy from "../../images/press-releases/Tracy_Kosolcharoen.jpg";
import PressImg01 from "../../images/press-releases/press-01.jpg";
import PressImg02 from "../../images/press-releases/press-02.jpg";
import PressImg03 from "../../images/press-releases/press-03.jpg";
import PressImg04 from "../../images/press-releases/press-04.jpg";
import PressImg05 from "../../images/press-releases/press-05.jpg";
import PressImg06 from "../../images/press-releases/press-06.jpg";
import PressImg07 from "../../images/press-releases/press-07.jpg";
import PressImg08 from "../../images/press-releases/press-08.jpg";
import PressImg09 from "../../images/press-releases/press-09.jpg";
import PressImg10 from "../../images/press-releases/press-10.jpg";
import PressImg11 from "../../images/press-releases/press-11.jpg";
import PressImg12 from "../../images/press-releases/press-12.jpg";
import PressImg13 from "../../images/press-releases/press-13.jpg";
import PressImg14 from "../../images/press-releases/press-14.jpg";
import PressImg15 from "../../images/press-releases/press-15.jpg";
import PressImg16 from "../../images/press-releases/press-16.jpg";
import PressImg17 from "../../images/press-releases/press-17.jpg";
import PressImg18 from "../../images/press-releases/press-18.jpg";
import PressImg19 from "../../images/press-releases/press-19.jpg";
import PressImg20 from "../../images/press-releases/press-20.jpg";
import AndrewFriedson from "../../images/press-releases/Andrew Friedson.jpg";
import AshokBaddi from "../../images/press-releases/Ashok Baddi.jpg";
import BridgetWatson from "../../images/press-releases/Bridget Watson.jpg";
import DrAnilKumar from "../../images/press-releases/Dr Anil Kumar.jpg";
import DrPrabuSelvam from "../../images/press-releases/Dr Prabu Selvam.jpg";
import HonLien from "../../images/press-releases/Hon Lien.jpg";
import IlanitEliaz from "../../images/press-releases/Ilanit Eliaz.jpg";
import ManishaPathak from "../../images/press-releases/Manisha Pathak.jpg";
import MichaelGates from "../../images/press-releases/Michael Gates.jpg";
import RakeshRamakrishnan from "../../images/press-releases/Rakesh Ramakrishnan.jpg";
import RodVilhauer from "../../images/press-releases/Rod Vilhauer.jpg";
import SantoshRao from "../../images/press-releases/Santosh Rao.jpg";
import SeemaKanani from "../../images/press-releases/seema kanani.jpg";
import SenatorMichaelWebber from "../../images/press-releases/Senator Michael Webber.jpg";
import ShriThanedar from "../../images/press-releases/Shri Thanedar .jpg";
import SteveHilton from "../../images/press-releases/Steve Hilton.jpg";
import TomKuhn from "../../images/press-releases/Tom Kuhn.jpg";
import ShivrajSingh from "../../images/press-releases/Shivraj Singh.jpg";
import MelindaLiu from "../../images/press-releases/Melinda Liu.jpg";
import SoniaSalwan from "../../images/press-releases/Sonia Salwan.jpg";
import KathyWatanabe from "../../images/press-releases/Kathy Watanabe.jpg";
import JenneAlderks from "../../images/press-releases/Jenne Alderks.jpg";
import gopalkrishan from "../../images/press-releases/Gopal Krishan.jpg";
import jayvaingankar2 from "../../images/press-releases/Jay Vaingankar.jpg";
import chiragrkathrani2 from "../../images/press-releases/Chirag R. Kathrani.jpg";
import deepikanaharas from "../../images/press-releases/Deepika Naharas.jpg";
import billhuizenga2 from "../../images/press-releases/Bill Huizenga.jpg";
import kismatrkathrani from "../../images/press-releases/Kismat R. Kathrani.jpg";
import prathiasonavane from "../../images/press-releases/Pratima Sonavne.jpg";
import renumalhotra from "../../images/press-releases/Renu Malhotra.jpg";
import muralisrinivasan from "../../images/press-releases/Murali Srinivasan.jpg";
import rakhiisrani from "../../images/press-releases/Rakhi Israni.jpg";
import vipinsharma from "../../images/press-releases/Vipin Sharma.jpg";
import rishrao from "../../images/press-releases/Rish Rao.jpg";
import jennyraeleroux from "../../images/press-releases/Jenny Rae Le Roux.jpg";
import carmen from "../../images/candidates/Carmen Montano.jpg";
import gopal2 from "../../images/press-releases/Gopal_Kumarappan.jpg";
import carol from "../../images/press-releases/Carol_Pefley.jpg";
import bill from "../../images/press-releases/Bill_Chuan.jpg";
import herb from "../../images/press-releases/Herb_Morgan.jpg";
import liang from "../../images/press-releases/Liang-Fang_Chao.jpg";
import mikerogers from "../../images/press-releases/Mike_Rogers.jpg";
import parker from "../../images/press-releases/Keith_Parker.jpg";
import moss from "../../images/press-releases/Jeremy_Moss.jpg";
import gloria from "../../images/press-releases/Gloria_Romero.jpg";
import fionama2 from "../../images/press-releases/Fiona_Ma.jpg";
import philweiser2 from "../../images/press-releases/Phil_Weiser.jpg";
import jasonlin2 from "../../images/press-releases/Jason_Lin.jpg";
import jasoncrow2 from "../../images/press-releases/Jason_Crow.jpg";
import julietesta2 from "../../images/press-releases/Julie_Testa.jpg";
import joshhoover2 from "../../images/press-releases/Josh_Hoover.jpg";
import darshanapatel2 from "../../images/press-releases/Darshana_Patel.jpg";
import brettmartinez2 from "../../images/press-releases/Brett_Martinez.jpg";
import paulsethy from "../../images/press-releases/Paul_Sethy.jpg";
import johnlovick from "../../images/press-releases/John_Lovick.jpg";
import shelleyklock from "../../images/press-releases/Shelley_Kloba.jpg";
import davinaduerr from "../../images/press-releases/Davina_Duerr.jpg";
import ronscoles from "../../images/press-releases/Ron_Scolesdang.jpg";
import daniellepenman from "../../images/press-releases/Danielle_Penman.jpg";
import gloria2 from "../../images/candidates/Gloria Romero.jpg";
import billchuan from "../../images/candidates/Bill-Chuan.png";
import liangfangchao from "../../images/candidates/Liang­Fang Chao.png";
import herbmorgan from "../../images/candidates/Herb_Morgan.png";
import mikerogers2 from "../../images/candidates/mike_rogers.png";
import rachna from "../../images/candidates/Rachna Sizemore Heizer.jpg";
import JamesWalkinshaw from "../../images/candidates/James Walkinshaw.jpg";
import KeithParker from "../../images/candidates/Parker.jpg";
import JeremyMoss from "../../images/candidates/jeremy.jpg";

import defaultCandidate from "../../images/default-candidate.png";
import winBadge from "../../images/win.png";
// import {Link} from 'react-scroll'

/* ---------- Hook: in-view trigger for entrance animation -
--------- */
function useInView({ threshold = 0.25, rootMargin = "0px 0px -10% 0px" } = {}) {
  const ref = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(([entry]) => setActive(entry.isIntersecting), {
      threshold,
      rootMargin,
    });

    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold, rootMargin]);

  // useEffect(() => {
  //     if (selected) {
  //       document.body.style.overflow = "hidden";
  //     } else {
  //       document.body.style.overflow = "auto";
  //     }
  //   }, [selected]);

  return { ref, active };
}

const DATA = [
  {
    "name": "2025/2026 ELECTION CYCLE ENDORSED CANDIDATES",
    subsections: [
      {
        name: "U.S. SENATE",
          candidates: [
            {
              "name": "Andy Barr",
              "Office": "U.S. Senate-Kentucky",
              "image": andy,
              "status": "Challenger",
              "Election Year": "2026",
              "Primary":"2026",
              "Result":"Upcoming",
  "zipCodes": [
    "38079","40003","40004","40006","40007","40008","40009","40010","40011","40012",
    "40013","40014","40019","40020","40022","40023","40025","40026","40031","40033",
    "40036","40037","40040","40041","40045","40046","40047","40049","40050","40051",
    "40052","40055","40056","40057","40058","40059","40060","40061","40062","40063",
    "40065","40067","40068","40069","40070","40071","40075","40076","40077","40078",
    "40104","40107","40108","40109","40110","40111","40115","40117","40118","40119",
    "40121","40140","40142","40143","40144","40145","40146","40150","40152","40155",
    "40157","40160","40161","40162","40165","40170","40171","40175","40176","40177",
    "40178","40202","40203","40204","40205","40206","40207","40208","40209","40210",
    "40211","40212","40213","40214","40215","40216","40217","40218","40219","40220",
    "40221","40222","40223","40228","40229","40231","40241","40242","40243","40245",
    "40258","40272","40280","40291","40299","40310","40311","40312","40313","40316",
    "40322","40324","40328","40330","40334","40336","40337","40339","40342","40346",
    "40347","40348","40350","40351","40353","40355","40356","40357","40358","40359",
    "40360","40361","40363","40370","40371","40372","40374","40376","40379","40380",
    "40383","40385","40387","40390","40391","40402","40403","40404","40409","40419",
    "40422","40434","40437","40440","40442","40444","40445","40447","40448","40456",
    "40460","40461","40464","40468","40472","40475","40481","40484","40486","40489",
    "40502","40503","40504","40505","40507","40508","40509","40510","40511","40513",
    "40514","40515","40516","40517","40526","40536","40601","40701","40729","40734",
    "40737","40740","40741","40744","40759","40763","40769","40771","40801","40803",
    "40806","40807","40808","40810","40813","40815","40816","40818","40819","40820",
    "40823","40824","40826","40827","40828","40829","40830","40831","40840","40843",
    "40844","40845","40847","40849","40854","40855","40856","40858","40862","40863",
    "40865","40868","40870","40873","40874","40902","40903","40906","40913","40914",
    "40915","40921","40923","40927","40935","40939","40940","40941","40943","40946",
    "40949","40953","40958","40962","40964","40965","40972","40977","40979","40981",
    "40982","40983","40988","40995","40997","41001","41002","41003","41004","41005",
    "41006","41007","41008","41010","41011","41014","41015","41016","41017","41018",
    "41030","41031","41033","41034","41035","41039","41040","41041","41042","41043",
    "41044","41045","41046","41048","41049","41051","41052","41055","41056","41059",
    "41063","41064","41071","41073","41074","41075","41076","41080","41083","41085",
    "41086","41091","41092","41093","41094","41095","41097","41098","41101","41102",
    "41121","41124","41129","41132","41135","41139","41141","41142","41143","41144",
    "41146","41149","41159","41164","41166","41168","41169","41171","41174","41175",
    "41179","41180","41181","41183","41189","41201","41203","41204","41214","41216",
    "41219","41222","41224","41226","41230","41231","41232","41234","41238","41240",
    "41250","41254","41255","41256","41257","41260","41262","41263","41264","41265",
    "41267","41268","41271","41274","41301","41310","41311","41314","41317","41332",
    "41339","41348","41351","41352","41360","41364","41365","41366","41367","41385",
    "41386","41390","41397","41408","41421","41425","41464","41465","41472","41501",
    "41503","41512","41513","41514","41517","41519","41522","41524","41526","41527",
    "41528","41531","41534","41535","41537","41538","41539","41540","41543","41544",
    "41547","41548","41553","41554","41555","41557","41558","41559","41560","41562",
    "41563","41564","41566","41567","41568","41571","41572","41601","41602","41603",
    "41604","41605","41606","41607","41612","41615","41616","41619","41621","41622",
    "41630","41631","41632","41635","41636","41640","41642","41643","41645","41647",
    "41649","41650","41651","41653","41655","41659","41660","41663","41666","41667",
    "41669","41701","41712","41713","41714","41719","41721","41722","41723","41725",
    "41727","41729","41731","41735","41739","41740","41745","41746","41749","41751",
    "41754","41759","41760","41762","41763","41764","41766","41772","41773","41774",
    "41775","41776","41777","41778","41804","41810","41812","41815","41817","41819",
    "41821","41822","41824","41825","41826","41828","41831","41832","41833","41834",
    "41835","41836","41837","41838","41839","41840","41843","41844","41845","41847",
    "41848","41849","41855","41858","41859","41861","41862","42001","42003","42020",
    "42021","42022","42023","42024","42025","42027","42028","42029","42031","42032",
    "42035","42036","42037","42038","42039","42040","42041","42044","42045","42047",
    "42048","42049","42050","42051","42053","42054","42055","42056","42058","42060",
    "42061","42064","42066","42069","42071","42076","42078","42079","42081","42082",
    "42083","42085","42086","42087","42088","42101","42103","42104","42120","42122",
    "42123","42124","42127","42129","42130","42131","42133","42134","42140","42141",
    "42151","42153","42154","42156","42157","42159","42160","42163","42164","42166",
    "42167","42170","42171","42202","42204","42206","42207","42210","42211","42214",
    "42215","42217","42220","42223","42232","42234","42236","42240","42252","42254",
    "42256","42259","42261","42262","42265","42266","42273","42274","42275","42276",
    "42280","42285","42286","42301","42303","42320","42321","42322","42323","42324",
    "42325","42326","42327","42328","42330","42332","42333","42337","42338","42339",
    "42343","42344","42345","42347","42348","42349","42350","42351","42352","42354",
    "42355","42356","42361","42366","42367","42368","42369","42370","42371","42372",
    "42374","42376","42378","42404","42406","42408","42409","42410","42411","42413",
    "42420","42431","42436","42437","42440","42441","42442","42444","42445","42450",
    "42451","42452","42453","42455","42456","42458","42459","42461","42462","42463",
    "42464","42501","42503","42516","42518","42519","42528","42533","42539","42541",
    "42544","42553","42565","42566","42567","42602","42603","42629","42631","42633",
    "42634","42635","42638","42642","42647","42649","42653","42701","42712","42713",
    "42715","42716","42717","42718","42721","42722","42724","42726","42728","42729",
    "42732","42733","42740","42741","42742","42743","42746","42748","42749","42753",
    "42754","42757","42758","42759","42762","42764","42765","42776","42782","42784","42788"
  ]
            },
            {
                "name": "Haley Stevens",
                "Office": "U.S. Senate-Michigan",
                "image": haley,
                "status": "Challenger",
                "Election Year": "2026",
                "Primary": "2026",
                "Result": "Upcoming",
  "zipCodes": [
"48001","48002","48003","48004","48005","48006","48007","48009","48012","48014",
"48015","48017","48021","48022","48023","48025","48026","48027","48028","48030",
"48032","48033","48034","48035","48036","48037","48038","48039","48040","48041",
"48042","48043","48044","48045","48046","48047","48048","48049","48050","48051",
"48054","48059","48060","48062","48063","48064","48065","48066","48067","48068",
"48069","48070","48071","48072","48073","48074","48075","48076","48079","48080",
"48081","48082","48083","48084","48085","48086","48088","48089","48090","48091",
"48092","48093","48094","48095","48096","48097","48098","48099","48101","48103",
"48104","48105","48106","48107","48108","48109","48110","48111","48112","48113",
"48114","48115","48116","48117","48118","48120","48121","48122","48123","48124",
"48125","48126","48127","48128","48130","48131","48133","48134","48135","48136",
"48137","48138","48139","48140","48141","48143","48144","48145","48146","48150",
"48151","48152","48153","48154","48157","48158","48159","48160","48161","48162",
"48164","48165","48166","48167","48168","48169","48170","48174","48175","48176",
"48177","48178","48179","48180","48182","48183","48184","48185","48186","48187",
"48188","48189","48190","48191","48192","48193","48195","48197","48198","48201",
"48202","48203","48204","48205","48206","48207","48208","48209","48210","48211",
"48212","48213","48214","48215","48216","48217","48218","48219","48220","48221",
"48222","48223","48224","48225","48226","48227","48228","48229","48230","48231",
"48232","48233","48234","48235","48236","48237","48238","48239","48240","48242",
"48243","48244","48255","48260","48264","48265","48266","48267","48268","48269",
"48272","48275","48277","48278","48279","48288"
  ]
                },
                {
                "name": "Jim Risch",
                "Office": "U.S. Senate-Idaho",
                "image": jim,
                "status": "Incumbent",
                "Election Year": "2026",
                "Primary": "2026",
                "Result": "Upcoming",
  "zipCodes": [
    "83120","83127","83201","83202","83203","83204","83209","83210","83211","83212",
    "83213","83214","83215","83217","83218","83220","83221","83223","83226","83227",
    "83228","83232","83233","83234","83235","83236","83237","83238","83239","83241",
    "83243","83244","83245","83246","83250","83251","83252","83253","83254","83255",
    "83261","83262","83263","83271","83272","83274","83276","83277","83278","83281",
    "83283","83285","83286","83287","83301","83302","83311","83312","83313","83314",
    "83316","83318","83320","83321","83322","83323","83324","83325","83327","83328",
    "83330","83332","83333","83334","83335","83336","83337","83338","83340","83341",
    "83342","83344","83346","83347","83348","83349","83350","83352","83353","83354",
    "83355","83401","83402","83404","83406","83420","83421","83422","83423","83424",
    "83425","83427","83428","83429","83431","83433","83434","83435","83436","83438",
    "83440","83442","83443","83444","83445","83446","83448","83449","83450","83451",
    "83452","83454","83455","83460","83462","83463","83464","83465","83466","83467",
    "83468","83469","83501","83520","83522","83523","83524","83525","83526","83530",
    "83535","83536","83537","83539","83540","83541","83542","83543","83544","83545",
    "83546","83547","83548","83549","83552","83553","83554","83555","83602","83604",
    "83605","83607","83610","83611","83612","83615","83616","83617","83619","83622",
    "83623","83624","83626","83627","83628","83629","83631","83632","83633","83634",
    "83636","83637","83638","83639","83641","83642","83643","83644","83645","83646",
    "83647","83648","83650","83651","83654","83655","83656","83657","83660","83661",
    "83666","83669","83670","83672","83676","83677","83686","83687","83702","83703",
    "83704","83705","83706","83709","83712","83713","83714","83716","83720","83725",
    "83801","83802","83803","83804","83805","83806","83808","83809","83810","83811",
    "83812","83813","83814","83815","83821","83822","83823","83824","83825","83826",
    "83827","83830","83832","83833","83834","83835","83836","83837","83839","83840",
    "83841","83842","83843","83844","83845","83846","83847","83848","83849","83850",
    "83851","83852","83854","83855","83856","83857","83858","83860","83861","83864",
    "83866","83867","83868","83869","83870","83871","83872","83873","83874","83876",
    "89832"
  ]
                }
            ]
        },
        {
          name: "U.S. HOUSE OF REPRESENTATIVES",
          candidates: [
            {
  "name": "Ethan Agarwal",
  "Office": "U.S. House-California 17",
  "image": ethan,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 16, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "94024","94043","94085","94086","94087","94089",
    "94536","94538","94539","94555","94560",
    "95002","95014","95035","95050","95051","95053","95054","95070",
    "95110","95112","95116","95117","95126","95127","95128","95129",
    "95130","95131","95132","95133","95134"
  ]
},
{
  "name": "Mike Rogers",
  "Office": "United States Senate - Michigan",
  "image": mikerogers2,
  "status": "Incumbent",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming — Election Nov 2026",
  "zipCodes": [
    "49085"
  ]
},
{
  "name": "Jeremy Moss",
  "Office": "U.S. House of Representatives-Michigan's 11th Congressional District",
  "image": JeremyMoss,
  "status": "Nominee",
  "Election Year": "2026",
  "Primary": "August 4, 2026",
  "Result": "Upcoming — General Election, November 3, 2026",
  "zipCodes": [
    "48009",
    "48017",
    "48025",
    "48030",
    "48067",
    "48069",
    "48070",
    "48071",
    "48072",
    "48073",
    "48083",
    "48084",
    "48085",
    "48098",
    "48167",
    "48220",
    "48237",
    "48301",
    "48302",
    "48304",
    "48320",
    "48322",
    "48323",
    "48324",
    "48326",
    "48327",
    "48328",
    "48329",
    "48331",
    "48334",
    "48335",
    "48336",
    "48340",
    "48341",
    "48342",
    "48346",
    "48377",
    "48382",
    "48383",
    "48386",
    "48390",
    "48393"
  ]
},
{
  "name": "Gregory W.Meeks",
  "Office": "U.S. House-New York 5",
  "image": Gregory,
  "status": "Incumbent (re-election)",
  "Election Year": "2026",
  "Primary": "2024",
  "Result": "Upcoming",
  "zipCodes": [
    "11411","11412","11413","11414","11415","11416","11417","11418","11419","11420",
    "11421","11422","11423","11424","11427","11428","11429","11430","11432","11433",
    "11434","11435","11436","11439",
    "11451",
    "11691","11692","11693","11694","11697"
  ]
},
{
  "name": "James Walkinshaw",
  "Office": "U.S. House-Virginia 11",
  "image": JamesWalkinshaw,
  "status": "Incumbent",
  "Election Year": "2026",
  "Primary": "August 4, 2026",
  "Result": "General Election — November 3, 2026",
  "zipCodes": [
    "20120","20121","20124","20151","20152","20170","20171","20190","20191","20194",
    "20195","22003","22015","22030","22031","22032","22033","22039","22042","22043",
    "22044","22046","22066","22079","22101","22102","22124","22150","22151","22152",
    "22153","22180","22181","22182","22185","22191","22192","22193","22194","22195",
    "22309","22310","22312","22315","22320","22331","22333","22334","22336","22350",
    "22351","22380"
  ]
},

// U.S. HOUSE OF REPRESENTATIVES

{
  "name": "Suhas Subramanyam",
  "Office": "U.S. House-Virginia 10",
  "image": suhas,
  "status": "Incumbent",
  "Election Year": "2026",
  "Primary": "August 4, 2026",
  "Result": "General Election — November 3, 2026",
  "zipCodes": [
    "20101","20102","20103","20104","20105","20106","20108","20109","20110","20111",
    "20112","20113","20115","20116","20117","20118","20120","20121","20124","20128",
    "20129","20130","20131","20132","20134","20135","20136","20137","20138","20139",
    "20140","20141","20142","20143","20144","20146","20147","20148","20149","20151",
    "20152","20155","20156","20158","20159","20160","20164","20165","20166","20167",
    "20168","20169","20170","20171","20175","20176","20177","20178","20180","20181",
    "20182","20184","20185","20186","20187","20188","20189","20197","20198","22030",
    "22039","22066","22192","22406","22556","22623","22627","22630","22639","22640",
    "22642","22643","22712","22713","22716","22720","22728","22734","22739","22740",
    "22742","22747","22749"
  ]
},
{
  "name": "Pia Dandiya",

  "Office": "U.S. House of Representatives - Florida's 22nd Congressional District",

  "image": piadan,

  "status": "Challenger",

  "Election Year": "2026",

  "Primary": "Aug 18, 2026",

  "Result": "Upcoming",

  "zipCodes": [
    "33498",
    "33496",
    "33487",
    "33484",
    "33483",
    "33480",
    "33473",
    "33472",
    "33470",
    "33467",
    "33463",
    "33462",
    "33461",
    "33460",
    "33449",
    "33446",
    "33445",
    "33444",
    "33437",
    "33436",
    "33435",
    "33426",
    "33415",
    "33414",
    "33413",
    "33411",
    "33407",
    "33406",
    "33405",
    "33401"
  ]
},
{
  "name": "Shri Thanedar",
  "Office": "U.S. House of Representatives – Michigan's 13th Congressional District",
  "image": thanedarImg,
  "status": "Incumbent",
  "Election Year": "2026",
  "Primary": "August 4, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48111",
    "48122",
    "48125",
    "48127",
    "48128",
    "48134",
    "48141",
    "48150",
    "48164",
    "48174",
    "48180",
    "48184",
    "48185",
    "48186",
    "48187",
    "48188",
    "48201",
    "48202",
    "48203",
    "48204",
    "48205",
    "48206",
    "48207",
    "48208",
    "48209",
    "48210",
    "48211",
    "48212",
    "48213",
    "48214",
    "48215",
    "48216",
    "48217",
    "48218",
    "48219",
    "48221",
    "48223",
    "48224",
    "48226",
    "48227",
    "48228",
    "48233",
    "48234",
    "48235",
    "48238",
    "48242"
  ]
},
{
  "name": "Jason Crow",
  "Office": "U.S. House of Representatives, Colorado's 6th Congressional District",
  "image": jasoncrow,
  "status": "Incumbent",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "80012",
    "80013",
    "80014",
    "80015",
    "80016",
    "80017",
    "80018",
    "80111",
    "80112",
    "80120",
    "80121",
    "80122",
    "80123",
    "80124",
    "80126",
    "80129",
    "80130"
  ]
},
{
  "name": "Dr. Anil Kumar",
  "Office": "U.S. Representative - Michigan's 11th Congressional District",
  "image": kumar,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Aug 4, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48009",
    "48025",
    "48033",
    "48034",
    "48037",
    "48071",
    "48075",
    "48076",
    "48084",
    "48098",
    "48301",
    "48302",
    "48304"
  ]
},
{
  "name": "Jimmy Patronis",
  "Office": "U.S. House-Florida 1",
  "image": jimmy,
  "status": "Incumbent",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "32433","32435","32439","32459",
    "32501","32502","32503","32504","32505","32506","32507","32508","32509",
    "32511","32512","32514","32526","32530","32531","32533","32534","32535",
    "32536","32539","32541","32542","32544","32547","32548","32550","32561",
    "32563","32564","32565","32566","32567","32568","32569","32570","32571",
    "32577","32578","32579","32580","32583"
  ]
},
{
  "name": "Randy Fine",
  "Office": "U.S. House-Florida 6",
  "image": randy,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "32033","32080","32086","32102","32110","32112","32113","32114","32117","32118",
    "32119","32124","32128","32130","32131","32133","32134","32136","32137","32139",
    "32140","32145","32147","32148","32157","32159","32162","32164","32174","32176",
    "32177","32179","32180","32181","32182","32187","32189","32190","32192","32193",
    "32195","32617","32640","32666","32702","32720","32723","32724","32726","32735",
    "32736","32757","32763","32767","32776","32784","34420","34470","34472","34475",
    "34476","34479","34480","34488","34491","34788"
  ]
},
{
  "name": "Rakhi Israni",
  "Office": "U.S. House-California 14",
  "image": rakhi,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "94505","94514","94536","94538","94539","94541","94542","94544","94545","94546",
    "94550","94551","94552","94555","94566","94568","94577","94578","94579","94580",
    "94586","94587","94588","94602","94619","95377","95391"
  ]
},
{
  "name": "Vin Kruttiventi",
  "Office": "U.S. House-California 13",
  "image": vin,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "93210","93234","93242","93606","93608","93609","93610","93620","93622","93624",
    "93627","93630","93635","93636","93637","93638","93640","93652","93656","93660",
    "93662","93665","93668","93706","93723","93725","95231","95301","95303","95304",
    "95307","95312","95313","95315","95316","95317","95319","95322","95324","95328",
    "95330","95333","95334","95337","95340","95341","95348","95351","95354","95357",
    "95358","95360","95363","95365","95369","95374","95377","95380","95385","95387",
    "95388"
  ]
},
{
  "name": "Sam Liccardo",
  "Office": "U.S. House-California 16",
  "image": samliccardo,
  "status": "Incumbent",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "94010","94018","94019","94020","94021","94022","94024","94025","94027","94028",
    "94037","94038","94040","94041","94043","94044","94060","94061","94062","94074",
    "94301","94303","94304","94305","94306","95008","95014","95030","95032","95033",
    "95070","95111","95112","95117","95118","95121","95122","95124","95125","95126",
    "95128","95129","95130","95136"
  ]
},
{
  "name": "Bruce Leon",
  "Office": "U.S. House-Illinois 9",
  "image": bruce,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "60004","60016","60022","60025","60026","60035","60043","60045","60053","60062",
    "60068","60076","60077","60089","60091","60093","60096","60099","60192","60201",
    "60202","60203","60613","60618","60625","60626","60630","60640","60645","60646",
    "60659","60660"
  ]
},
{
  "name": "Mike Lawler",
  "Office": "U.S. House-New York 17",
  "image": mike,
  "status": "Incumbent",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "10501","10504","10505","10506","10507","10509","10510","10511","10512","10514",
    "10516","10517","10518","10519","10520","10524","10526","10527","10532","10535",
    "10536","10537","10540","10541","10542","10545","10546","10547","10548","10549",
    "10560","10562","10566","10567","10570","10576","10578","10579","10588","10589",
    "10590","10591","10594","10595","10596","10597","10598","10603","10604","10901",
    "10911","10913","10920","10923","10927","10931","10952","10954","10956","10960",
    "10962","10964","10965","10968","10970","10974","10976","10977","10980","10983",
    "10984","10986","10989","10993","10994","12531","12533","12563","12564","12570",
    "12582","12590"
  ]
},
{
  "name": "Scott Wiener",
  "Office": "U.S. House-California 11",
  "image": scotwiener,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "94102","94103","94104","94105","94107","94108","94109","94110","94111","94112",
    "94114","94115","94116","94117","94118","94121","94122","94123","94124","94127",
    "94129","94130","94131","94132","94133","94134","94158","94188"
  ]
},
{
  "name": "Bill Huizenga",
  "Office": "U.S. House-Michigan 4",
  "image": billhuizenga,
  "status": "Incumbent",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "49001","49002","49004","49006","49007","49008","49009","49010","49012","49013",
    "49014","49015","49017","49022","49024","49026","49027","49033","49034","49037",
    "49038","49043","49045","49048","49052","49053","49055","49056","49057","49060",
    "49063","49064","49065","49070","49071","49074","49078","49079","49080","49083",
    "49084","49085","49087","49088","49090","49098","49315","49316","49323","49328",
    "49335","49344","49348","49406","49408","49418","49419","49423","49424","49426",
    "49428","49434","49450","49453","49460","49464"
  ]

},

{
  "name": "Anuj Dixit",
  "Office": "U.S. House-California",
  "image": anuj,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Withdrawn",
  "zipCodes": [
"07001","07002","07003","07008","07016","07017","07018","07021",
"07023","07024","07027","07028","07030","07032","07033","07036",
"07040","07041","07042","07043","07044","07045","07046","07047"
  ]
},
{
  "name": "Rishi Kumar",
  "Office": "U.S. House-California",
  "image": rishi,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
"94024","94040","94041","94043","94085","94086","94087","94089",
"94301","94303","94304","94305",
"95002","95014","95035","95050","95051","95053","95054","95070",
"95110","95112","95116","95117","95126","95127","95128","95129",
"95130","95131","95132","95133","95134"
  ]
},

          ]
        },
        {
          name: "GOVERNOR",
            "candidates": [
                {
  "name": "Steve Hilton",
  "Office": "Governor-California",
  "image": steve,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
"90001","90002","90003","90004","90005","90006","90007","90008","90010","90011",
"90012","90013","90014","90015","90016","90017","90018","90019","90020","90021",
"90022","90023","90024","90025","90026","90027","90028","90029","90031","90032",
"90033","90034","90035","90036","90037","90038","90039","90040","90041","90042",
"90043","90044","90045","90046","90047","90048","90049","90056","90057","90058",
"90059","90061","90062","90063","90064","90065","90066","90067","90068","90069",
"90071","90077","90089","90094",
"90201","90210","90211","90212","90220","90221","90222","90230","90232","90240",
"90241","90242","90245","90247","90248","90249","90250","90254","90255","90260",
"90262","90265","90266","90270","90272","90274","90275","90277","90278","90280",
"90290","90291","90292","90293",
"90301","90302","90303","90304","90305",
"90401","90402","90403","90404","90405",
"90501","90502","90503","90504","90505",
"90601","90602","90603","90604","90605","90606","90620","90621","90623","90630",
"90631","90638","90640","90650","90660","90670",
"90701","90703","90706","90710","90712","90713","90715","90717","90720","90723",
"90731","90732","90744","90745","90746","90747","90755",
"90802","90803","90804","90805","90806","90807","90808","90810","90813","90814",
"90815","90822",
"91001","91006","91007","91010","91011","91016","91020","91024","91030","91040",
"91042",
"91101","91103","91104","91105","91106","91107","91108",
"91201","91202","91203","91204","91205","91206","91207","91208","91210","91214",
"91301","91302","91303","91304","91306","91307","91311","91316","91320","91321",
"91324","91325","91326","91331","91335","91340","91342","91343","91344","91345",
"91351","91352","91354","91355","91356","91360","91361","91362","91364","91367",
"91381","91384",
"91401","91402","91403","91405","91406","91411","91423","91436",
"91501","91502","91504","91505","91506",
"91601","91602","91604","91605","91606","91607",
"91701","91702","91706","91709","91710","91711","91722","91723","91724","91730",
"91731","91732","91733","91737","91739","91740","91741","91744","91745","91746",
"91748","91750","91752","91754","91755","91761","91762","91763","91764","91765",
"91766","91767","91768","91770","91773","91775","91776","91780","91784","91786",
"91789","91790","91791","91792",
"91801","91803"
  ]
},
{
  "name": "Phil Weiser",
  "Office": "Governor of Colorado",
  "image": philweiser,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "80002",
    "80003",
    "80004",
    "80005",
    "80010",
    "80012",
    "80013",
    "80014",
    "80202",
    "80203",
    "80204",
    "80205",
    "80206",
    "80209",
    "80210",
    "80301",
    "80302",
    "80501",
    "80903",
    "81501"
  ]
},
{
  "name": "Vivek Ramaswamy",
  "Office": "Governor-Ohio",
  "image": vivek2,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",

}
            ]
        },
        {
          name: "STATEWIDE EXECUTIVE — CALIFORNIA",
            candidates: [
                {
  "name": "Ben Allen",
  "Office": "California Commissioner of Insurance",
  "image": benallen,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
},

{
  "name": "Herb W Morgan",
  "Office": "California State Controller",
  "image": herbmorgan,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming — Election Nov 2026",
  "zipCodes": [
    "95324"
  ]
},
{
  "name": "Gloria Romero",
  "Office": "Lieutenant Governor, California",
  "image": gloria2,
  "status": "Nominee",
  "Election Year": "2026",
  "Primary": "June 2, 2026",
  "Result": "Upcoming — General Election, November 3, 2026",
  "zipCodes": [
  "90001", "90002", "90003", "90004", "90005", "90006", "90007", "90008", "90010", "90011",
  "90012", "90013", "90014", "90015", "90016", "90017", "90018", "90019", "90020", "90021",
  "90022", "90023", "90024", "90025", "90026", "90027", "90028", "90029", "90031", "90032",
  "90033", "90034", "90035", "90036", "90037", "90038", "90039", "90040", "90041", "90042",
  "90043", "90044", "90045", "90046", "90047", "90048", "90049", "90056", "90057", "90058"
]
},
{
  "name": "Michael Gates",
  "Office": "California Attorney General",
  "image": gates,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "90001", // Los Angeles
    "90011",
    "90017",
    "90210", // Beverly Hills
    "90250", // Hawthorne
    "90277", // Redondo Beach
    "90401", // Santa Monica
    "90503", // Torrance
    "90650", // Norwalk
    "90745", // Carson
    "90802", // Long Beach
    "91006", // Arcadia
    "91101", // Pasadena
    "91203", // Glendale
    "91331", // Pacoima
    "91355", // Santa Clarita
    "91401", // Van Nuys
    "91502", // Burbank
    "91711", // Claremont
    "91745", // Hacienda Heights
    "91761", // Ontario
    "91801", // Alhambra
    "91910", // Chula Vista
    "92024", // Encinitas
    "92037", // La Jolla
    "92101", // San Diego
    "92126", // Mira Mesa
    "92260", // Palm Desert
    "92335", // Fontana
    "92408", // San Bernardino
    "92501", // Riverside
    "92553", // Moreno Valley
    "92612", // Irvine
    "92647", // Huntington Beach
    "92704", // Santa Ana
    "92801", // Anaheim
    "92840", // Garden Grove
    "92868", // Orange
    "93003", // Ventura
    "93101", // Santa Barbara
    "93301", // Bakersfield
    "93401", // San Luis Obispo
    "93611", // Clovis
    "93721", // Fresno
    "93940", // Monterey
    "94016", // Daly City
    "94080", // South San Francisco
    "94102", // San Francisco
    "94301", // Palo Alto
    "94401", // San Mateo
    "94501", // Alameda
    "94538", // Fremont
    "94544", // Hayward
    "94550", // Livermore
    "94568", // Dublin
    "94577", // San Leandro
    "94596", // Walnut Creek
    "94607", // Oakland
    "94704", // Berkeley
    "95014", // Cupertino
    "95035", // Milpitas
    "95050", // Santa Clara
    "95110", // San Jose
    "95202", // Stockton
    "95350", // Modesto
    "95616", // Davis
    "95630", // Folsom
    "95670", // Rancho Cordova
    "95758", // Elk Grove
    "95814", // Sacramento
    "95928", // Chico
    "96001", // Redding
  ]
},
{
  "name": "Malia Cohen",
  "Office": "California Controller",
  "image": maliacohen,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
},
{
  "name": "Eleni Kounalakis",
  "Office": "California Treasurer",
  "image": elenikounalakis,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
},
{
  "name": "Fiona Ma",
  "Office": "Lieutenant Governor-California",
  "image": fionama,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
},
{
  "name": "Josh Newman",
  "Office": "California Superintendent of Public Instruction",
  "image": joshnewman,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
},
{
  "name": "Donald P. Wagner",
  "Office": "California Secretary of State",
  "image": donaldpwagner,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
}
            ]
        },
        {
          name: "STATEWIDE EXECUTIVE — OTHER STATES",
            candidates: [
                {
  "name": "Jason Miyares",
  "Office": "Attorney General-Virginia",
  "image": jason,
  "status": "Incumbent (re-election)",
  "Election Year": "2025 (Virginia cycle)",
  "Primary": "2025",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
}
            ]
        },
        {
          name: "STATE LEGISLATURE",
            candidates: [
                {
  "name": "Patrick Ahrens",
  "Office": "California State Assembly-District 26",
  "image": patrick,
  "status": "Incumbent (re-election)",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
},
{
  "name": "Danielle Penman",
  "Office": "Illinois State Senate, District 33",
  "image": daniellepenman2,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "60102",
    "60110",
    "60118",
    "60119",
    "60120",
    "60123",
    "60134",
    "60136",
    "60140",
    "60142",
    "60156",
    "60174",
    "60175",
    "60177",
    "60178",
    "60180",
    "60183",
    "60184"
  ]
},
{
  "name": "Davina Duerr",
  "Office": "Washington State House of Representatives, Legislative District 1, Position 1",
  "image": davinaduerr2,
  "status": "Incumbent",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "98011",
    "98012",
    "98021",
    "98028",
    "98034",
    "98036",
    "98037",
    "98043",
    "98072",
    "98077"
  ]
},
{
  "name": "Shelley Kloba",
  "Office": "Washington State Representative, Legislative District 1, Position 2",
  "image": shelleykloba2,
  "status": "Incumbent",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "98011",
    "98012",
    "98021",
    "98028",
    "98034",
    "98036",
    "98037",
    "98043",
    "98072",
    "98077"
  ]
},
{
  "name": "John Lovick",
  "Office": "Washington State Senate, Legislative District 44",
  "image": jhonlovick2,
  "status": "Incumbent",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "98012",
    "98020",
    "98026",
    "98036",
    "98037",
    "98043",
    "98046",
    "98072",
    "98087",
    "98201",
    "98203",
    "98204",
    "98208"
  ]
},
{
  "name": "Darshana Patel",
  "Office": "California State Assembly, District 76",
  "image": darshanapatel,
  "status": "Incumbent",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "92003",
    "92007",
    "92008",
    "92009",
    "92010",
    "92011",
    "92024",
    "92028",
    "92054",
    "92056",
    "92057",
    "92058",
    "92078",
    "92081",
    "92083",
    "92084",
    "92091",
    "92672"
  ]
},
{
  "name": "Tom Kuhn",
  "Office": "Michigan House of Representatives – District 57",
  "image": tomkuhn,
  "status": "Incumbent",
  "Election Year": "2026",
  "Primary": "August 4, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48071",
    "48072",
    "48083",
    "48084",
    "48085",
    "48098",
    "48310",
    "48312",
    "48313",
    "48314"
  ]
},
{
  "name": "Michael Webber",
  "Office": "Michigan State Senate – District 9",
  "image": webber,
  "status": "Incumbent",
  "Election Year": "2026",
  "Primary": "August 4, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48007",
    "48083",
    "48084",
    "48085",
    "48087",
    "48098",
    "48306",
    "48307",
    "48309",
    "48310",
    "48311",
    "48312",
    "48313",
    "48314",
    "48315",
    "48316",
    "48317",
    "48363"
  ]
},
{
  "name": "Dr. Rakesh Ramakrishnan",
  "Office": "Michigan State Senate - District 7",
  "image": drrakeshramakrishnan,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Aug 4, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48009",
    "48025",
    "48033",
    "48034",
    "48037",
    "48070",
    "48071",
    "48072",
    "48073",
    "48075",
    "48076",
    "48084",
    "48085",
    "48098",
    "48301",
    "48302",
    "48304",
    "48322",
    "48323",
    "48324",
    "48327",
    "48328",
    "48329",
    "48341",
    "48342",
    "48343",
    "48346"
  ]
},
{
  "name": "Bridget Watson",
  "Office": "Michigan House of Representatives - District 47",
  "image": bridgetWatson,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Aug 4, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48103",
    "48104",
    "48105",
    "48108",
    "48113",
    "48118",
    "48176"
  ]
},
{
  "name": "Ashok Baddi",
  "Office": "Michigan House of Representatives-56th District",
  "image": ashok,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming — Election Nov 2026",
  "zipCodes": [
    "48017","48073","48083","48084","48085","48098","48304"
  ]
},
{
  "name": "Rosaura Bagolie (Rosy)",
  "Office": "New Jersey General Assembly-District 27",
  "image": rosaura,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming — Election Nov 2026",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
},
{
  "name": "Marc Berman",
  "Office": "California State Assembly-District 23",
  "image": marcberman,
  "status": "Incumbent (re-election)",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "94010","94018","94019","94020","94021","94022","94024","94025","94027","94028",
    "94037","94038","94040","94041","94043","94044","94060","94061","94062","94063",
    "94070","94074","94085",
    "94301","94303","94304","94305","94306",
    "94402",
    "95008","95014","95030","95032","95033","95070",
    "95117","95125","95128","95129","95130"
  ]
},
{
  "name": "David Cohen",
  "Office": "California State Senate-District 10",
  "image": davidcohen,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
},
{
  "name": "Geary Higgins",
  "Office": "Virginia House of Delegates-District 30",
  "image": geary,
  "status": "Incumbent (re-election)",
  "Election Year": "2025 (Virginia cycle)",
  "Primary": "2025",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
},
{
  "name": "Jenne Alderks",
  "Office": "Washington State Representative-1st Legislative District, Position 2",
  "image": Jenne,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Aug 4, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "98011","98012","98021","98028","98033","98034","98036","98041",
    "98072","98077","98087","98155"
  ]
},
{
  "name": "Chirag R. Kathrani",
  "Office": "California State Assembly-District 16",
  "image": chiragrkathrani,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "94505","94506","94507","94513","94514","94516","94517","94518","94521","94523",
    "94526","94528","94539","94546","94549","94550","94551","94552","94556","94563",
    "94566","94568","94575","94582","94583","94586","94588","94595","94596","94597",
    "94598",
    "95377","95391"
  ]
},
{
  "name": "Alex Lee",
  "Office": "California State Assembly-District 24",
  "image": alexlee,
  "status": "Incumbent (re-election)",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "94536","94538","94539","94552","94555","94560","94566","94586","94588",
    "95035","95054",
    "95110","95112","95116","95127","95131","95132","95133","95134"
  ]
},
{
  "name": "Eric Lucan",
  "Office": "California State Assembly-District 12",
  "image": ericlucan,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "94901","94903","94904","94920","94924","94925","94928","94929","94930","94931",
    "94933","94937","94938","94939","94940","94941","94945","94946","94947","94949",
    "94950","94951","94952","94954","94956","94957","94960","94963","94964","94965",
    "94970","94971","94973",
    "95404","95405","95407","95409","95431","95442","95452","95472","95476"
  ]
},
{
  "name": "Carol Pefley",
  "Office": "California State Assembly-District 28",
  "image": carolpefley,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "95003","95005","95006","95007","95008","95013","95017","95018","95020",
    "95030","95032","95033","95037","95041","95046","95060","95062","95064","95065","95066",
    "95070","95073","95076",
    "95110","95112","95118","95119","95120","95123","95124","95125","95126",
    "95136","95138","95139"
  ]
},
{
  "name": "Gail Pellerin",
  "Office": "California State Assembly-District 28",
  "image": gailpellerin,
  "status": "Incumbent (re-election)",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "95003","95005","95006","95007","95008","95013","95017","95018","95020",
    "95030","95032","95033","95037","95041","95046","95060","95062","95064","95065","95066",
    "95070","95073","95076",
    "95110","95112","95118","95119","95120","95123","95124","95125","95126",
    "95136","95138","95139"
  ]
},
{
  "name": "Rakesh Ramakrishnan",
  "Office": "Michigan State Senate-(District TBD)",
  "image": rakesh,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming — Election Nov 2026",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
},
{
  "name": "Jay Vaingankar",
  "Office": "New Jersey General Assembly-District 12",
  "image": jayvaingankar,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming — Election Nov 2026",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
},


            ]
        },
        {
          name: " STATE BOARD",
            candidates: [
                {
  "name": "John Pimentel",
  "Office": "California Board of Equalization-District 2",
  "image": johnpimentel,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
}
            ]
        },
        {
          name: "COUNTY — JUDICIARY",
            candidates: [
                {
  "name": "Selia Warren",
  "Office": "Superior Court-Alameda County, California",
  "image": seliawarren,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
   "zipCodes": [
    "94501","94502",
    "94536","94537","94538","94539","94540","94541","94542","94543","94544","94545","94546",
    "94550","94551","94552","94555","94560","94566","94568",
    "94577","94578","94579","94580",
    "94586","94587","94588",

    "94601","94602","94603","94604","94605","94615",
    "94617","94618","94619","94620","94621",
    "94623","94624","94625","94626","94627",
    "94661","94662",

    "94702","94703","94704","94705","94706","94707","94708","94709","94710",
    "94712","94720"
  ]
}
            ]
        },
        {
          name: " COUNTY — DISTRICT ATTORNEY",
            candidates: [
                {
  "name": "Gopal Krishan",
  "Office": "District Attorney-Alameda County, California",
  "image": gopal,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "94501","94502",
    "94536","94537","94538","94539","94540","94541","94542","94543","94544","94545","94546",
    "94550","94551","94552","94555","94560","94566","94568",
    "94577","94578","94579","94580",
    "94586","94587","94588",
    
    "94601","94602","94603","94604","94605","94615",
    "94617","94618","94619","94620","94621",
    "94623","94624","94625","94626","94627",
    "94661","94662",
    
    "94702","94703","94704","94705","94706","94707","94708","94709","94710",
    "94712","94720"
  ]
},
{
  "name": "Jeff Rosen",
  "Office": "District Attorney-Santa Clara County, California",
  "image": jeffrosen,
  "status": "Incumbent (re-election)",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
}
            ]
        },
        {
          name: "COUNTY — ASSESSOR",
            candidates: [
                {
  "name": "Neysa Fligor",
  "Office": "Assessor-Santa Clara County, California",
  "image": neysafligor,
  "status": "Incumbent (re-election)",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
},
{
  "name": "Kismat R. Kathrani",
  "Office": "Assessor-Contra Costa County, California",
  "image": kismat,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
}
            ]
        },
        {
          name: "COUNTY — FISCAL OFFICES",
            candidates: [
                {
  "name": "Deepika Naharas",
  "Office": "Auditor-Controller-Contra Costa County, California",
  "image": deepika,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "94505","94506","94507","94508","94509","94510","94511","94512","94513","94514",
    "94515","94516","94517","94518","94519","94520","94521","94522","94523","94524",
    "94525","94526","94527","94528","94529","94530","94531",
    "94547","94548","94549",
    "94553","94554","94555","94556","94557","94558","94559","94560","94561","94562",
    "94563","94564","94565","94566","94567","94568","94569","94570","94571","94572",
    "94575","94577","94578","94579","94580","94581","94582","94583","94584","94585",
    "94586","94587","94588","94589","94590","94591","94592","94593","94594","94595",
    "94596","94597","94598",
    "94801","94802","94803","94804","94805","94806","94807","94808",
    "94820"
  ]
},
{
  "name": "Pratima Sonavane",
  "Office": "Clerk-Recorder-Contra Costa County, California",
  "image": pratima,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
}
            ]
        },
        {
          name: "COUNTY — WATER BOARD",
            candidates: [
                {
  "name": "Rish Rao",
  "Office": "Water Board-Contra Costa County, California",
  "image": rish,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "94505","94506","94507","94509","94511","94513","94514","94516","94517","94518",
    "94519","94520","94521","94522","94523","94524","94525","94526","94527","94528",
    "94529","94530","94531","94547","94548","94549","94553","94556","94561","94563",
    "94564","94565","94569","94570","94572","94575","94582","94583","94595","94596",
    "94597","94598",
    "94801","94802","94803","94804","94805","94806","94807","94808",
    "94820"
  ]
}
            ]
        },
        {
          name: "COUNTY — EDUCATION",
            candidates: [
                {
  "name": "Alysse Castro",
  "Office": "Superintendent of Schools-Alameda County, California",
  "image": alysse,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
},
{
  "name": "Paul Sethy",
  "Office": "Alameda County Water District Board of Directors, Ward 3, California",
  "image": paulsethy2,
  "status": "Incumbent",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "94536",
    "94537",
    "94538",
    "94539",
    "94555",
    "94560",
    "94587"
  ]
},
{
  "name": "Sangeetha Shanbhogue",
  "Office": "Board of Education, 7th Trustee Area-Alameda County, California",
  "image": san,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
}
            ]
        },
        {
          name: "CITY / LOCAL",
            candidates: [
                {
  "name": "Aditya Ahlawat",
  "Office": "Town Council-Apex, North Carolina",
  "image": aditya,
  "status": "Challenger",
  "Election Year": "2025/2026",
  "Primary": "2025/2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
},
{
  "name": "Keith Parker",
  "Office": "City Council-District 2, Fremont, California",
  "image": KeithParker,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "N/A",
  "Result": "Upcoming — General Election, November 3, 2026",
  "zipCodes": [
    "94536",
    "94538",
    "94539",
    "94555"
  ]
},
{
  "name": "Julie Testa",
  "Office": "Mayor of Pleasanton, California",
  "image": julietesta,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "94566",
    "94588"
  ]
},
{
  "name": "Gopal Kumarappan",
  "Office": "Cupertino City Council, Cupertino, California",
  "image": gopalkurappan,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "",
  "Result": "Upcoming",
  "zipCodes": [
    "95014",
    "95015"
  ]
},
{
  "name": "Rachna Sizemore Heizer",
  "Office": "Fairfax County Board of Supervisors-Braddock District",
  "image": rachna,
  "status": "Incumbent",
  "Election Year": "2026",
  "Primary": "N/A",
  "Result": "Not on 2026 Ballot",
  "zipCodes": [
    "22003","22015","22030","22031","22032","22033","22042","22043","22044",
    "22046","22079","22150","22151","22152","22153","22181","22182","22185",
    "22186","22192","22193","22309","22310","22312","22315"
  ]
},
{
  "name": "Bill Chuan",
  "Office": "Milpitas City Council - At Large",
  "image": billchuan,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "N/A",
  "Result": "Upcoming — Election Nov 2026",
  "zipCodes": [
    "95035",
    "95036"
  ]
},
{
  "name": "Seema Kanani",
  "Office": "Milpitas City Council",
  "image": seemakanani,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "N/A (Nonpartisan Municipal Election)",
  "Result": "Upcoming",
  "zipCodes": [
    "95035",
    "95036"
  ]
},
{
  "name": "Santosh Rao",
  "Office": "Cupertino City Council",
  "image": santoshrao,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "N/A (Nonpartisan General Election)",
  "Result": "Upcoming",
  "zipCodes": [
    "95014",
    "95015"
  ]
},
{
  "name": "Vipin Sharma",

  "Office": "Fremont City Council - District 3, California",

  "image": vipin2,

  "status": "Challenger",

  "Election Year": "2026",

  "Primary": "",

  "Result": "Upcoming",

  "zipCodes": []
},
{
  "name": "Lynette Lee Eng",

  "Office": "Los Altos City Council - District 2, California",

  "image": lynette,

  "status": "Challenger",

  "Election Year": "2026",

  "Primary": "",

  "Result": "Upcoming",

  "zipCodes": []
},
{
  "name": "Tracy Kosolcharoen",

  "Office": "Cupertino City Council, California",

  "image": tracykosolcharoen,

  "status": "Challenger",

  "Election Year": "2026",

  "Primary": "",

  "Result": "Upcoming",

  "zipCodes": []
},
{
  "name": "Rod Vilhauer",
  "Office": "Mayor of Frisco",
  "image": rod,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "May 2, 2026 (General Election)",
  "Result": "Runoff Election (June 13, 2026)",
  "zipCodes": [
    "75033",
    "75034",
    "75035",
    "75036",
    "75068"
  ]
},
{
  "name": "Manisha Pathak",
  "Office": "Fremont City Council - District 4",
  "image": manishapathak,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "N/A (Nonpartisan Election)",
  "Result": "Upcoming",
  "zipCodes": [
    "94536",
    "94537",
    "94538",
    "94539",
    "94555"
  ]
},
{
  "name": "Hon Lien",
  "Office": "Montgomery County Council At-Large",
  "image": honglien,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 23, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "20812",
    "20814",
    "20815",
    "20816",
    "20817",
    "20818",
    "20832",
    "20833",
    "20837",
    "20838",
    "20839",
    "20841",
    "20842",
    "20850",
    "20851",
    "20852",
    "20853",
    "20854",
    "20855",
    "20860",
    "20861",
    "20862",
    "20866",
    "20868",
    "20871",
    "20872",
    "20874",
    "20875",
    "20876",
    "20877",
    "20878",
    "20879",
    "20880",
    "20882",
    "20886",
    "20895",
    "20896",
    "20898",
    "20901",
    "20902",
    "20903",
    "20904",
    "20905",
    "20906",
    "20910",
    "20912"
  ]
},
{
  "name": "Dr. Prabu Selvam",
  "Office": "Montgomery County Council At-Large",
  "image": drprabuselvam,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 23, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "20812",
    "20814",
    "20815",
    "20816",
    "20817",
    "20818",
    "20832",
    "20833",
    "20837",
    "20838",
    "20839",
    "20841",
    "20842",
    "20850",
    "20851",
    "20852",
    "20853",
    "20854",
    "20855",
    "20860",
    "20861",
    "20862",
    "20866",
    "20868",
    "20871",
    "20872",
    "20874",
    "20875",
    "20876",
    "20877",
    "20878",
    "20879",
    "20880",
    "20882",
    "20886",
    "20895",
    "20896",
    "20898",
    "20901",
    "20902",
    "20903",
    "20904",
    "20905",
    "20906",
    "20910",
    "20912"
  ]
},
{
  "name": "Hector Marin",
  "Office": "City Council, District 4-Santa Cruz, California",
  "image": hector,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 2, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "95060","95062","95064"
  ]
},
{
  "name": "Jag Nagendra",
  "Office": "City Council, District 3-Folsom, California",
  "image": jag,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
},
{
  "name": "Kathy Watanabe",
  "Office": "Mayor-Santa Clara, California",
  "image": kathy,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "N/A (Nonpartisan General Election)",
  "Result": "Upcoming — Election Nov 3, 2026",
  "zipCodes": [
    "95050","95051","95052","95053","95054","95055","95056"
  ]
},
{
  "name": "Shivraj Singh",
  "Office": "Dublin City Council-District 4, California",
  "image": shivraj,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "N/A (Nonpartisan General Election)",
  "Result": "Upcoming — Election Nov 3, 2026",
  "zipCodes": [
    "94568"
  ]
},
{
  "name": "Melinda Liu",
  "Office": "Irvine City Council-District 1, California",
  "image": Melinda,
  "status": "Incumbent (re-election)",
  "Election Year": "2026",
  "Primary": "N/A (Nonpartisan General Election)",
  "Result": "Upcoming — Election Nov 3, 2026",
  "zipCodes": [
    "92602","92620"
  ]
},
{
  "name": "Hon. Theresa Rich",
  "Office": "Mayor-Farmington Hills, Michigan",
  "image": theresarich,
  "status": "Incumbent (re-election)",
  "Election Year": "2025/2026",
  "Primary": "2025/2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
},
{
  "name": "Murali Srinivasan",
  "Office": "City Council-Sunnyvale, California",
  "image": murali,
  "status": "Incumbent (re-election)",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
   "zipCodes": [
    "94085","94086","94087","94088","94089"
  ]
},
{
  "name": "Andrew Friedson",
  "Office": "Montgomery County Executive",
  "image": andrewfriedson,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "Jun 23, 2026",
  "Result": "Upcoming",
  "zipCodes": [
    "20812",
    "20814",
    "20815",
    "20816",
    "20817",
    "20818",
    "20854"
  ]
},
            ]
        },
        {
          name: "SCHOOL / DISTRICT BOARDS",
            candidates: [
                {
  "name": "Chinmay Nagarkar",
  "Office": "Issaquah School Board, District 2-Washington State",
  "image": chinmay,
  "status": "Challenger",
  "Election Year": "2025/2026",
  "Primary": "2025/2026",
  "Result": "Upcoming",
  "zipCodes": [
    "48201",
    "48208",
    "48210",
    "48214",
    "48227"
  ]
},
{
  "name": "Jason Lin",
  "Office": "Fremont Union High School District Board of Trustees, Trustee Area 3, California",
  "image": jasonlin,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "94022",
    "94024",
    "94040",
    "94041",
    "94043",
    "94085",
    "94086",
    "94087",
    "94089",
    "95014"
  ]
},
{
  "name": "Ron Scolesdang",
  "Office": "Irvine Unified School District Board of Education, Trustee Area 2, California",
  "image": ronscolesdang2,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "92602",
    "92603",
    "92604",
    "92606",
    "92612",
    "92614",
    "92617",
    "92618",
    "92620"
  ]
},
{
  "name": "Brett Martinez",
  "Office": "Pleasanton Unified School District Board, Area 5, California",
  "image": brettmartinez,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "94566",
    "94588"
  ]
},
{
  "name": "Josh Hoover",
  "Office": "California State Assembly, District 7",
  "image": joshhoover,
  "status": "Incumbent",
  "Election Year": "2026",
  "Primary": "2026",
  "Result": "Upcoming",
  "zipCodes": [
    "95628",
    "95630",
    "95662",
    "95670",
    "95671",
    "95677",
    "95678",
    "95683",
    "95742",
    "95746",
    "95747",
    "95757",
    "95758",
    "95765"
  ]
},
{
  "name": "Liang Fang Chao",
  "Office": "Foothill-De Anza Community College District Board - Trustee Area 4",
  "image": liangfangchao,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "N/A",
  "Result": "Upcoming — Election Nov 2026",
  "zipCodes": [
    "95014",
    "95050",
    "95051",
    "95053",
    "95054",
    "95070"
  ]
},
{
  "name": "Ilanit Eliaz",
  "Office": "Fremont Union High School District Board of Trustees-Trustee Area 4, Sunnyvale, California",
  "image": Ilanit,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "N/A (Nonpartisan General Election)",
  "Result": "Upcoming — Election Nov 3, 2026",
  "zipCodes": [
    "94087"
  ]
},
{
  "name": "Sonia Salwan",
  "Office": "Ohlone Community College District Board of Trustees-Area 6, California",
  "image": Sonia,
  "status": "Challenger",
  "Election Year": "2026",
  "Primary": "N/A (Nonpartisan General Election)",
  "Result": "Upcoming — Election Nov 3, 2026",
  "zipCodes": [
    "94539"
  ]
}
            ]
        }
      ]
    },
{
  "name": "2024 ELECTION CYCLE ENDORSED CANDIDATES",
  subsections: [
    {
      name: "U.S. HOUSE OF REPRESENTATIVES",
      candidates: [
        {
  "name": "Scott Baugh",
  "Office": "U.S. House-California 47",
  "image": scott,
  "status": "Challenger (open-seat race)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Buddy Carter",
  "Office": "U.S. House-Georgia 1",
  "image": buddy,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": [
    "30002","30004","30005","30008","30009","30011","30012","30013","30014","30016","30017","30018","30019","30021","30022","30024","30025","30028","30030","30032","30033","30034","30035","30038","30039","30040","30041","30043","30044","30045","30046","30047","30052","30054","30055","30056","30058","30060","30062","30064","30066","30067","30068","30070","30071","30072","30075","30076","30078","30079","30080","30082","30083","30084","30087","30088","30090","30092","30093","30094","30096","30097",
    
    "30101","30102","30103","30104","30105","30106","30107","30108","30110","30111","30113","30114","30115","30116","30117","30118","30120","30121","30122","30124","30125","30126","30127","30132","30134","30135","30137","30139","30141","30143","30144","30145","30147","30148","30149","30152","30153","30157","30161","30165","30168","30170","30171","30173","30175","30176","30177","30178","30179","30180","30182","30183","30184","30185","30187","30188","30189",
    
    "30204","30205","30206","30213","30214","30215","30216","30217","30218","30220","30222","30223","30224","30228","30229","30230","30233","30234","30236","30238","30240","30241","30248","30250","30251","30252","30253","30256","30257","30258","30259","30260","30263","30265","30268","30269","30272","30273","30274","30275","30276","30277","30281","30284","30285","30286","30288","30289","30290","30291","30292","30293","30294","30295","30296","30297",
    
    "30303","30305","30306","30307","30308","30309","30310","30311","30312","30313","30314","30315","30316","30317","30318","30319","30322","30324","30326","30327","30328","30329","30331","30332","30334","30336","30337","30338","30339","30340","30341","30342","30344","30345","30346","30349","30350","30354","30360","30363",
    
    "30401","30410","30411","30412","30413","30414","30415","30417","30420","30421","30423","30425","30426","30427","30428","30434","30436","30439","30441","30442","30445","30446","30448","30449","30450","30451","30452","30453","30454","30455","30456","30457","30458","30460","30461","30464","30467","30470","30471","30473","30474","30477","30478","30479",
    
    "30501","30502","30503","30504","30505","30506","30507","30508","30509","30510","30511","30512","30513","30514","30515","30516","30517","30518","30519","30520","30521","30522","30523","30524","30525","30527","30528","30529","30530","30531","30533","30534","30535","30536","30537","30538","30539","30540","30541","30542","30543","30545","30546","30547","30548","30549","30552","30553","30554","30555","30557","30558","30559","30560","30562","30563","30564","30565","30566","30567","30568","30571","30572","30573","30575","30576","30577","30578","30579",
    
    "30601","30602","30605","30606","30607","30609","30619","30620","30621","30622","30623","30624","30625","30627","30628","30629","30630","30631","30633","30634","30635","30639","30641","30642","30643","30646","30648","30650","30655","30656","30660","30662","30663","30664","30665","30666","30667","30668","30669","30673","30677","30678","30680","30683",
    
    "30701","30705","30707","30708","30710","30711","30720","30721","30724","30725","30726","30728","30730","30731","30733","30734","30735","30736","30738","30739","30740","30741","30742","30746","30747","30750","30751","30752","30753","30755","30756","30757",
    
    "30802","30803","30805","30807","30810","30812","30813","30814","30815","30816","30817","30818","30820","30821","30822","30823","30824","30828","30830","30833",
    
    "30901","30904","30905","30906","30907","30909","30912",
    
    "31001","31002","31003","31004","31005","31006","31007","31008","31009","31011","31012","31014","31015","31016","31017","31018","31019","31020","31021","31022","31023","31024","31025","31027","31028","31029","31030","31031","31032","31033","31034","31035","31036","31037","31038","31039","31041","31042","31044","31045","31046","31047","31049","31050","31051","31052","31054","31055","31057","31058","31060","31061","31062","31063","31064","31065","31066","31067","31068","31069","31070","31071","31072","31075","31076","31077","31078","31079","31081","31082","31083","31084","31085","31087","31088","31089","31090","31091","31092","31093","31094","31096","31097","31098",
    
    "31201","31204","31206","31207","31210","31211","31213","31216","31217","31220",
    
    "31301","31302","31303","31305","31307","31308","31309","31312","31313","31314","31315","31316","31318","31320","31321","31322","31323","31324","31326","31327","31328","31329","31331","31333",
    
    "31401","31404","31405","31406","31407","31408","31409","31410","31411","31415","31419","31421",
    
    "31501","31503","31510","31512","31513","31516","31518","31519","31520","31522","31523","31524","31525","31527","31532","31533","31535","31537","31539","31542","31543","31544","31545","31546","31547","31548","31549","31550","31551","31552","31553","31554","31555","31556","31557","31558","31560","31561","31562","31563","31564","31565","31566","31567","31568","31569","31599",
    
    "31601","31602","31605","31606","31620","31622","31623","31624","31625","31629","31632","31635","31636","31637","31638","31639","31641","31642","31643","31645","31647","31648","31649","31650",
    
    "31701","31704","31705","31707","31709","31711","31716","31719","31721","31730","31735","31738","31743","31757","31763","31764","31765","31773","31778","31779","31780","31784","31787","31792",
    
    "31801","31803","31805","31806","31808","31810","31812","31814","31815","31816","31820","31821","31824","31825","31826","31827","31829","31831","31832","31836",
    
    "31901","31903","31904","31905","31906","31907","31909"
  ]
},
{
  "name": "Judy Chu",
  "Office": "U.S. House-California 28",
  "image": judy,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": [
    "91001","91006","91007","91011","91016","91020","91024","91030",
    "91101","91103","91104","91105","91106","91107","91108","91125",
    "91214",
    "91701","91702","91711","91737","91739","91741","91750","91754","91755","91759",
    "91770","91775","91776","91780","91784",
    "91801","91803",
    "92358","92371","92397",
    "92407",
    "93543","93550","93553","93563"
  ]
},
{
  "name": "The Late Gerry Connolly",
  "Office": "U.S. House-Virginia 11",
  "image": gerry,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Service Concluded",
  "zipCodes": [
    "20120","20121","20124","20151","20170","20171","20190","20191","20194",
    "22003","22015","22027","22030","22031","22032","22033","22035","22039",
    "22066","22079",
    "22102","22124","22150","22151","22152","22153","22180","22181","22182",
    "22310","22315"
  ]
},

{
  "name": "Danny K. Davis",
  "Office": "U.S. House-Illinois 7",
  "image": danny,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Lloyd Doggett",
  "Office": "U.S. House-Texas 37",
  "image": lloyd,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
   "zipCodes": [
    "78652",
    "78701","78703","78704","78705","78712","78717","78722","78723","78726",
    "78727","78728","78729","78731","78732","78733","78739","78745","78746",
    "78748","78749","78750","78751","78752","78753","78756","78757","78758","78759"
  ]
},
{
  "name": "Pat Fallon",
  "Office": "U.S. House-Texas 4",
  "image": pat,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Hank Johnson",
  "Office": "U.S. House-Georgia 4",
  "image": hank,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": [
    "30021","30032","30034","30035","30038","30044","30058","30071","30072","30083",
    "30084","30087","30088","30092","30093","30096","30097",
    "30319","30338","30340","30341","30345","30346",
    "30360"
  ]
},
{
  "name": "Glenn Ivey",
  "Office": "U.S. House-Maryland 4",
  "image": glenn,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": [
    "20705","20706","20707","20708","20710","20712","20720","20722","20735","20737",
    "20740","20742","20743","20744","20745","20746","20747","20748","20769","20770",
    "20771","20781","20782","20783","20784","20785",
    "20866","20868",
    "20904","20905","20912"
  ]
},
{
  "name": "Darrell Issa",
  "Office": "U.S. House-California 48",
  "image": darrell,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Sheila Jackson Lee",
  "Office": "U.S. House-Texas 18",
  "image": sheila,
  "status": "Incumbent",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Deceased",
  "zipCodes": []
},
{
  "name": "Marcy Kaptur",
  "Office": "U.S. House-Ohio 9",
  "image": marcy,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": [
    "43406","43407","43408","43410","43412","43416","43420","43430","43431","43432",
    "43433","43434","43435","43436","43438","43439","43440","43442","43445","43446",
    "43447","43449","43452","43456","43457","43458","43460","43464","43465","43468",
    "43469","43501","43502","43504","43505","43506","43512","43515","43517","43518",
    "43519","43520","43521","43522","43526","43528","43530","43531","43533","43536",
    "43537","43540","43542","43543","43547","43548","43549","43551","43553","43554",
    "43556","43557","43558","43560","43566","43567","43570","43571",
    "43604","43605","43606","43607","43608","43609","43610","43611","43612","43613",
    "43614","43615","43616","43617","43619","43620","43623",
    "44089",
    "44811","44814","44824","44836","44839","44841","44846","44847","44870","44889"
  ]
},
{
  "name": "Young Kim",
  "Office": "U.S. House-California 40",
  "image": kim,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": [
    "91709",
    "92602","92610","92630","92637","92653","92656","92676","92678","92679",
    "92688","92691","92692",
    "92705",
    "92780","92782",
    "92806","92807","92808","92821","92823",
    "92861","92865","92866","92867","92869","92880","92882","92886","92887"
  ]
},
{
  "name": "Raja Krishnamoorthi",
  "Office": "U.S. House-Illinois 8",
  "image": raja,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "George Latimer",
  "Office": "U.S. House-New York 16",
  "image": George,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": [
    "10466","10475",
    "10502","10503","10522","10523","10528","10530","10533","10538","10543",
    "10550","10552","10553","10573","10577","10580","10583","10591",
    "10601","10603","10604","10605","10606","10607",
    "10701","10703","10704","10705","10706","10707","10708","10709","10710",
    "10801","10803","10804","10805"
  ]
},
{
  "name": "Mike Lawler",
  "Office": "U.S. House-New York 17",
  "image": mike,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": [
    "10501","10504","10505","10506","10507","10509","10510","10511","10512","10514",
    "10516","10517","10518","10519","10520","10524","10526","10527","10532","10535",
    "10536","10537","10540","10541","10542","10545","10546","10547","10548","10549",
    "10560","10562","10566","10567","10570","10576","10578","10579","10588","10589",
    "10590","10591","10594","10595","10596","10597","10598",
    "10603","10604",
    "10901","10911","10913","10920","10923","10927","10931","10952","10954","10956",
    "10960","10962","10964","10965","10968","10970","10974","10976","10977","10980",
    "10983","10984","10986","10989","10993","10994",
    "12531","12533","12563","12564","12570","12582","12590"
  ]
},
{
  "name": "Evan Low",
  "Office": "U.S. House-California 16",
  "image": evan,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "James McGovern",
  "Office": "U.S. House-Massachusetts 2",
  "image": james,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Gregory W.Meeks",
  "Office": "U.S. House-New York 5",
  "image": Gregory,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": [
    "11411","11412","11413","11414","11415","11416","11417","11418","11419","11420",
    "11421","11422","11423","11424","11427","11428","11429","11430","11432","11433",
    "11434","11435","11436","11439",
    "11451",
    "11691","11692","11693","11694","11697"
  ]
},
{
  "name": "Rich McCormick",
  "Office": "U.S. House-Georgia 6",
  "image": rich,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": [
    "30004","30005","30009","30022","30024","30028","30040","30041",
    "30075","30076","30097",
    "30107","30115","30143","30148","30188",
    "30328","30350",
    "30504","30506","30518","30528","30533","30534","30542",
    "30564","30566","30597"
  ]
},
{
  "name": "Max Miller",
  "Office": "U.S. House-Ohio 7",
  "image": max,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": [
    "44017","44022","44070",
    "44116","44125","44126","44129","44130","44131","44133","44134","44136","44138","44139",
    "44140","44141","44142","44144","44145","44146","44147","44149",
    "44212","44214","44215","44217","44230","44233","44235","44251","44253","44254","44256",
    "44270","44273","44274","44275","44276","44280","44281","44287",
    "44606","44611","44618","44624","44627","44633","44638","44645","44659","44661","44666","44667",
    "44676","44677","44691",
    "44842"
  ]
},
{
  "name": "Kevin Mullin",
  "Office": "U.S. House-California 15",
  "image": kevin,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": [
    "94002","94005","94010","94014","94015","94025","94030","94061","94063","94065",
    "94066","94070","94080",
    "94112","94128","94134",
    "94303",
    "94401","94402","94403","94404"
  ]
},
{
  "name": "Joe Neguse",
  "Office": "U.S. House-Colorado 2",
  "image": joe,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Eleanor Holmes Norton",
  "Office": "Delegate to U.S. House-District of Columbia",
  "image": eleanor,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Linda Sánchez",
  "Office": "U.S. House-California 38",
  "image": linda,
  "status": "Incumbent",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Service Concluded",
  "zipCodes": [
    "91752",
    "92201","92203","92210","92211","92220","92223","92234","92253","92258","92260","92262","92264","92270","92274","92276","92282",
    "92320","92324","92373","92399",
    "92503","92504","92505","92506","92508","92530","92532","92536","92539","92543","92544","92545","92548","92549","92555","92557",
    "92561","92562","92563","92567","92570","92571","92582","92583","92584","92585","92586","92587","92592","92595","92596",
    "92860","92879","92880","92881","92882","92883"
  ]
},
{
  "name": "Brad Schneider",
  "Office": "U.S. House-Illinois 10",
  "image": schneider,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Brad Sherman",
  "Office": "U.S. House-California 32",
  "image": sherman,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": [
    "90024","90025","90046","90049","90069","90073","90077",
    "90210","90263","90265","90272","90290",
    "90402",
    "91301","91302","91303","91304","91306","91307","91311","91316",
    "91324","91325","91326","91330","91335","91343","91356","91364",
    "91367","91371",
    "91401","91403","91406","91411","91423","91436",
    "91602","91604"
  ]
},
{
  "name": "Michelle Steel",
  "Office": "U.S. House-California 45",
  "image": michelle,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Suhas Subramanyam",
  "Office": "U.S. House-Virginia 10",
  "image": suhas,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": [
    "20105","20106","20109","20110","20111","20112","20115","20117","20119","20120",
    "20121","20124","20129","20130","20132","20135","20136","20137","20141","20143",
    "20144","20147","20148","20152","20155","20158","20164","20165","20166","20169",
    "20175","20176","20180","20181","20184","20186","20187",
    "20197","20198",
    "22039","22192",
    "22623","22627","22639","22640","22642","22643",
    "22712","22713","22716","22720","22728","22734","22740","22742","22747","22749"
  ]
},
{
  "name": "Shri Thanedar",
  "Office": "U.S. House-Michigan 13",
  "image": thanedarImg,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": [
    "48101","48122","48125","48146","48174","48180","48184","48192","48195",
    "48201","48202","48203","48204","48205","48206","48207","48208","48209",
    "48210","48211","48212","48213","48214","48215","48216","48217","48218",
    "48221","48224","48225","48229","48233","48234","48236","48238","48242",
    "48243"
  ]
},
{
  "name": "Troy Nehls",
  "Office": "U.S. House-Texas 22",
  "image": troy,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": [
    "77406","77407","77414","77415","77417","77419","77420","77428","77430","77432",
    "77434","77435","77436","77437","77440","77441","77443","77444","77448","77449",
    "77450","77451","77453","77454","77455","77456","77457","77458","77459","77461",
    "77464","77465","77467","77468","77469","77471","77476","77477","77478","77479",
    "77480","77481","77482","77483","77485","77488","77494","77498",
    "77511","77578","77581","77583","77584"
  ]
},
{
  "name": "Ritchie Torres",
  "Office": "U.S. House-New York 15",
  "image": ritchie,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": [
    "10451","10452","10453","10454","10455","10456","10457","10458","10459",
    "10460","10461","10462","10463","10466","10467","10469","10470","10471"
  ]
},
{
  "name": "Juan Vargas",
  "Office": "U.S. House-California 52",
  "image": juan,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": [
    "91902","91910","91911","91913","91914","91915","91932","91950",
    "92102","92104","92105","92113","92114","92115","92136","92139",
    "92154","92173","92179"
  ]
},
{
  "name": "Vin Kruttiventi",
  "Office": "U.S. House-California 14",
  "image": vin,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": [
    "93210","93234","93242",
    "93606","93608","93609","93610","93620","93622","93624","93627","93630",
    "93635","93636","93637","93638","93640","93652","93656","93660","93662",
    "93665","93668",
    "93706","93723","93725",
    "95231",
    "95301","95303","95304","95307","95312","95313","95315","95316","95317",
    "95319","95322","95324","95328","95330","95333","95334","95337","95340",
    "95341","95348","95351","95354","95357","95358","95360","95363","95365",
    "95369","95374","95377","95380","95385","95387","95388"
  ]
}
      ]
    },

    {
      name: "CALIFORNIA STATE LEGISLATURE",
      candidates: [
        {
  "name": "Kristie Bruce-Lane",
  "Office": "California State Assembly-District 76",
  "image": kristie,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Steven Choi",
  "Office": "California State Senate-District 37",
  "image": steven,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Lydia Kou",
  "Office": "California State Assembly-District 23",
  "image": lydia,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Sangeetha Shanbhogue",
  "Office": "California State Assembly-District 20",
  "image": san,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Patrick Ahrens",
  "Office": "California State Assembly-District 26",
  "image": patrick,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": [
    "94024","94043","94085","94086","94087","94089",
    "95002","95008","95014","95050","95051","95053","95054","95070",
    "95110","95117","95125","95126","95128","95129",
    "95134"
  ]
}
      ]
    },

    {
      name: "COUNTY",
      candidates: [
        {
  "name": "Pamela Price",
  "Office": "District Attorney-Alameda County, California",
  "image": pamela,
  "status": "Incumbent",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Recalled",
  "zipCodes": []
},
{
  "name": "Madison Nguyen",
  "Office": "Santa Clara County Supervisor",
  "image": madison,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Lynette Lee Eng",
  "Office": "El Camino Healthcare District Board-Santa Clara County",
  "image": lynette,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
}
      ]
    },

    {
      name: "CITY / LOCAL",
      candidates: [
        {
  "name": "Richa Awasthi",
  "Office": "City Council-Foster City, California",
  "image": Richa,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Arjun Batra",
  "Office": "City Council-San Jose, California",
  "image": arjun,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Domingo Candelas",
  "Office": "City Council-San Jose, California",
  "image": domingo,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Ashish Garg",
  "Office": "City Council-Dublin, California",
  "image": ashish,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Lisa Gillmor",
  "Office": "Mayor-Santa Clara, California",
  "image": lisa,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Currently Serving",
  "zipCodes": []
},
{
  "name": "Raj Salwan",
  "Office": "Mayor-Fremont, California",
  "image": Raj,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Yang Shao",
  "Office": "Vice Mayor / City Council-Fremont, California",
  "image": yang,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": [
    "94536","94538","94539","94552","94555","94560","94566","94586","94588",
    "95035","95054",
    "95110","95112","95116","95127","95131","95132","95133","95134"
  ]
},
{
  "name": "Ray Wang",
  "Office": "City Council-Cupertino, California",
  "image": ray,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Zeel Ahir",
  "Office": "City Council-Artesia, California",
  "image": zeel,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Vikesh Patel",
  "Office": "City Council-La Palma, California",
  "image": vikesh,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Kitty Moore",
  "Office": "City Council-Cupertino, California",
  "image": kitty,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Teresa Keng",
  "Office": "City Council-Fremont, California",
  "image": teresa,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Chandrashekhar Wagh",
  "Office": "City Council-Fremont, California",
  "image": chandrashekhar,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Teresa Cox",
  "Office": "City Council-Fremont, California",
  "image": teresacox,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Carmen Montano",
  "Office": "Mayor-Milpitas, California",
  "image": carmen,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Dipak Awasthi",
  "Office": "City Council-Milpitas, California",
  "image": dipak,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Hon Lien",
  "Office": "Mayor-Milpitas, California",
  "image": hon,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Renu Malhotra",
  "Office": "City Council-Newark, California",
  "image": renu,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Satish Chandra Vale",
  "Office": "City Council-Santa Clara, California",
  "image": satish,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Chirag Kathrani",
  "Office": "Mayor-San Ramon, California",
  "image": chirag,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Vasanth Shetty",
  "Office": "City Council District 1-San Ramon, California",
  "image": vasanth,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Larry Klein",
  "Office": "Mayor-Sunnyvale, California",
  "image": larry,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Neel Patel",
  "Office": "City Council-Laguna Hills, California",
  "image": neel,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Tammy Kim",
  "Office": "Mayor-Irvine, California",
  "image": timmy,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Lily Mei",
  "Office": "Mayor-Fremont, California",
  "image": lily,
  "status": "Incumbent (previously endorsed)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Service Concluded",
  "zipCodes": []
}
      ]
    },

    {
      name: "SCHOOL / DISTRICT BOARDS",
      candidates: [
        {
  "name": "Aegean Lee",
  "Office": "Fremont Union High School District Board-California",
  "image": lee,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
},
{
  "name": "Long Jiao",
  "Office": "Cupertino Union School District Board-California",
  "image": long,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Rinu Nair",
  "Office": "Fremont Unified School District Board-California",
  "image": rinu,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Vivek Prasad",
  "Office": "Fremont Unified School District Board District 5-California",
  "image": vivek,
  "status": "Incumbent (re-election)",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Won — Currently Serving",
  "zipCodes": []
},
{
  "name": "Lakshmi Sharma",
  "Office": "Cupertino Union School District Board-California",
  "image": sharma,
  "status": "Challenger",
  "Election Year": "2024",
  "Primary": "2024",
  "Result": "Election Lost",
  "zipCodes": []
}
      ]
    }
  ]
},
{
  "name": "PREVIOUSLY ENDORSED & FUNDED CANDIDATES",
  subsections: [
    {
      name: "U.S. SENATE",
      candidates: [
        {
          "name": "Cindy Hyde-Smith",
          "Office": "U.S. Senate-Mississippi",
          "image": cindy,
          "status": "Incumbent",
          "Election Year": "Pre-2024",
          "Primary": "2024",
          "Result": "Election Lost",
          "zipCodes": [
    "38601","38603","38606","38610","38611","38614","38617","38618","38619","38620",
    "38621","38622","38623","38625","38626","38627","38629","38631","38632","38633",
    "38635","38637","38639","38641","38642","38643","38644","38645","38646","38647",
    "38650","38651","38652","38654","38655","38658","38659","38661","38663","38664",
    "38665","38666","38668","38670","38671","38672","38673","38674","38676","38677",
    "38680","38683","38685",
    
    "38701","38703","38720","38721","38722","38723","38725","38726","38730","38731",
    "38732","38733","38736","38737","38738","38740","38744","38745","38746","38748",
    "38751","38753","38754","38756","38759","38760","38761","38762","38764","38765",
    "38767","38768","38769","38771","38772","38773","38774","38776","38778","38781",
    
    "38801","38804","38821","38824","38826","38827","38828","38829","38833","38834",
    "38838","38839","38841","38843","38844","38846","38847","38848","38849","38850",
    "38851","38852","38853","38854","38855","38856","38857","38858","38859","38860",
    "38862","38863","38864","38865","38866","38868","38869","38870","38871","38873",
    "38876","38878","38879","38880","38883","38884","38886","38888",
    
    "38901","38913","38914","38915","38916","38917","38920","38921","38923","38924",
    "38925","38927","38928","38929","38930","38940","38941","38943","38944","38946",
    "38947","38948","38949","38950","38951","38952","38953","38954","38957","38961",
    "38962","38963","38964","38965","38966","38967",
    
    "39038","39039","39040","39041","39042","39044","39045","39046","39047","39051",
    "39054","39056","39057","39058","39059","39061","39062","39063","39066","39067",
    "39069","39071","39073","39074","39078","39079","39082","39083","39086","39088",
    "39090","39092","39094","39095","39096","39097",
    
    "39108","39110","39111","39113","39114","39115","39116","39117","39119","39120",
    "39140","39144","39145","39146","39148","39149","39150","39152","39153","39154",
    "39156","39157","39159","39160","39162","39166","39167","39168","39169","39170",
    "39173","39174","39175","39176","39177","39179","39180","39183","39188","39191",
    "39192","39193","39194",
    
    "39201","39202","39203","39204","39206","39208","39209","39210","39211","39213",
    "39216","39217","39218","39232","39269","39272",
    
    "39301","39305","39306","39307","39309","39320","39322","39323","39324","39325",
    "39326","39327","39328","39330","39332","39333","39335","39336","39337","39338",
    "39339","39340","39341","39342","39345","39346","39347","39348","39350","39352",
    "39354","39355","39356","39358","39359","39360","39361","39362","39363","39364",
    "39365","39366","39367",
    
    "39401","39402","39406","39421","39422","39423","39425","39426","39427","39428",
    "39429","39437","39439","39440","39443","39451","39452","39455","39456","39459",
    "39461","39462","39464","39465","39466","39470","39474","39475","39476","39477",
    "39478","39479","39480","39481","39482","39483",
    
    "39501","39503","39507","39520","39525","39529","39530","39531","39532","39534",
    "39540","39553","39556","39560","39561","39562","39563","39564","39565","39567",
    "39571","39572","39573","39574","39576","39577","39581","39595",
    
    "39601","39629","39630","39631","39633","39635","39638","39641","39643","39645",
    "39647","39648","39652","39653","39654","39655","39656","39657","39658","39659",
    "39660","39661","39662","39663","39664","39665","39666","39667","39668","39669",
    
    "39701","39702","39705","39730","39735","39736","39737","39738","39739","39740",
    "39741","39743","39744","39745","39746","39747","39750","39751","39752","39753",
    "39755","39756","39759","39762","39766","39767","39769","39771","39772","39773",
    "39776"
  ]
        }
      ]
    },

    {
      name: "U.S. HOUSE OF REPRESENTATIVES",
      candidates: [
        {
          "name": "Darrell Issa",
          "Office": "U.S. House-California 48",
          "image": darrell,
          "status": "Incumbent",
          "Election Year": "Pre-2024",
          "Primary": "Pre-2024",
          "Result": "Also endorsed 2024 — Election Won — Currently Serving",
          "zipCodes": []
        },
        
        {
          "name": "Young Kim",
          "Office": "U.S. House-California 40",
          "image": kim,
          "status": "Incumbent",
          "Election Year": "Pre-2024",
          "Primary": "Pre-2024",
          "Result": "Also endorsed 2024 — Election Won — Currently Serving",
          "zipCodes": [
    "91709",
    "92602","92610","92630","92637","92653","92656","92676","92678","92679",
    "92688","92691","92692",
    "92705",
    "92780","92782",
    "92806","92807","92808","92821","92823",
    "92861","92865","92866","92867","92869","92880","92882","92886","92887"
  ]
        },
        {
          "name": "Kevin McCarthy",
          "Office": "U.S. House-California",
          "image": kevin,
          "status": "Incumbent at time of endorsement",
          "Election Year": "Pre-2024",
          "Primary": "Pre-2024",
          "Result": "Service Concluded",
          "zipCodes": []
        },
        {
          "name": "Rich McCormick",
          "Office": "U.S. House-Georgia 6",
          "image": rich,
          "status": "Incumbent",
          "Election Year": "Pre-2024",
          "Primary": "Pre-2024",
          "Result": "Also endorsed 2024 — Election Won — Currently Serving",
          "zipCodes": [
    "30004","30005","30009","30022","30024","30028","30040","30041",
    "30075","30076","30097",
    "30107","30115","30143","30148","30188",
    "30328","30350",
    "30504","30506","30518","30528","30533","30534","30542",
    "30564","30566","30597"
  ]
        },
        {
          "name": "Troy Nehls",
          "Office": "U.S. House-Texas 22",
          "image" : troy,
          "status": "Incumbent",
          "Election Year": "Pre-2024",
          "Primary": "Pre-2024",
          "Result": "Also endorsed 2024 — Election Won — Currently Serving",
          "zipCodes": [
    "91752",
    "92201","92203","92210","92211","92220","92223","92234","92253","92258","92260","92262","92264","92270","92274","92276","92282",
    "92320","92324","92373","92399",
    "92503","92504","92505","92506","92508","92530","92532","92536","92539","92543","92544","92545","92548","92549","92555","92557",
    "92561","92562","92563","92567","92570","92571","92582","92583","92584","92585","92586","92587","92592","92595","92596",
    "92860","92879","92880","92881","92882","92883"
  ]
        },
        {
          "name": "Devin Nunes",
          "Office": "U.S. House-California 22",
          "image": devin,
          "status": "Incumbent at time of endorsement",
          "Election Year": "Pre-2022",
          "Primary": "Pre-2022",
          "Result": "Service Concluded",
          "zipCodes": []
        },
        {
          "name": "Pat Fallon",
          "Office": "U.S. House-Texas 4",
          "image": pat,
          "status": "Incumbent",
          "Election Year": "Pre-2024",
          "Primary": "Pre-2024",
          "Result": "Also endorsed 2024 — Election Won — Currently Serving",
          "zipCodes": []
        },
        {
          "name": "Linda Sánchez",
          "Office": "U.S. House-California 38",
          "image": linda,
          "status": "Incumbent at time of endorsement",
          "Election Year": "Pre-2024",
          "Primary": "Pre-2024",
          "Result": "Service Concluded — Retired",
          "zipCodes": [
    "91752",
    "92201","92203","92210","92211","92220","92223","92234","92253","92258","92260","92262","92264","92270","92274","92276","92282",
    "92320","92324","92373","92399",
    "92503","92504","92505","92506","92508","92530","92532","92536","92539","92543","92544","92545","92548","92549","92555","92557",
    "92561","92562","92563","92567","92570","92571","92582","92583","92584","92585","92586","92587","92592","92595","92596",
    "92860","92879","92880","92881","92882","92883"
  ]
        },
        {
          "name": "Michelle Steel",
          "Office": "U.S. House-California 45",
          "image": michelle,
          "status": "Incumbent",
          "Election Year": "Pre-2024",
          "Primary": "Pre-2024",
          "Result": "Also endorsed 2024 — Election Lost",
          "zipCodes": []
        }
      ]
    }
  ]
},
{
  "name": "HINDU BUDDHIST SIKH JAIN (HBSJ) CAUCUS MEMBERS",
  subsections: [
    {
      name: "U.S. HOUSE OF REPRESENTATIVES — HBSJ CAUCUS MEMBERS",
      candidates: [
        {
          "name": "Sanford Bishop",
          "Office": "U.S. House-Georgia 2",
          "image": sanford,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
          "zipCodes": [
    "31006","31007","31008","31016","31028","31030","31039","31041","31050","31051",
    "31052","31057","31058","31063","31066","31068","31070","31076","31078","31081",
    "31088","31091","31092","31093","31098",
    "31201","31204","31206","31207","31211","31213","31216","31217",
    "31626",
    "31701","31704","31705","31707","31709","31711","31716","31719","31721","31730",
    "31735","31738","31743","31757","31763","31764","31765","31773","31778","31779",
    "31780","31784","31787","31792",
    "31801","31803","31805","31806","31808","31810","31812","31814","31815","31816",
    "31820","31821","31824","31825","31826","31827","31829","31831","31832","31836",
    "31901","31903","31904","31905","31906","31907","31909",
    "39813","39815","39817","39819","39823","39824","39825","39826","39827","39828",
    "39832","39834","39836","39837","39840","39841","39842","39845","39846","39851",
    "39854","39859","39861","39862","39866","39867","39870","39877","39885","39886","39897"
  ]
        },
        {
                "name": "Haley Stevens",
                "Office": "U.S. Senate-Michigan",
                "image": haley,
                "status": "Challenger",
                "Election Year": "2026",
                "Primary": "2026",
                "Result": "Upcoming",
  "zipCodes": [
"48001","48002","48003","48004","48005","48006","48007","48009","48012","48014",
"48015","48017","48021","48022","48023","48025","48026","48027","48028","48030",
"48032","48033","48034","48035","48036","48037","48038","48039","48040","48041",
"48042","48043","48044","48045","48046","48047","48048","48049","48050","48051",
"48054","48059","48060","48062","48063","48064","48065","48066","48067","48068",
"48069","48070","48071","48072","48073","48074","48075","48076","48079","48080",
"48081","48082","48083","48084","48085","48086","48088","48089","48090","48091",
"48092","48093","48094","48095","48096","48097","48098","48099","48101","48103",
"48104","48105","48106","48107","48108","48109","48110","48111","48112","48113",
"48114","48115","48116","48117","48118","48120","48121","48122","48123","48124",
"48125","48126","48127","48128","48130","48131","48133","48134","48135","48136",
"48137","48138","48139","48140","48141","48143","48144","48145","48146","48150",
"48151","48152","48153","48154","48157","48158","48159","48160","48161","48162",
"48164","48165","48166","48167","48168","48169","48170","48174","48175","48176",
"48177","48178","48179","48180","48182","48183","48184","48185","48186","48187",
"48188","48189","48190","48191","48192","48193","48195","48197","48198","48201",
"48202","48203","48204","48205","48206","48207","48208","48209","48210","48211",
"48212","48213","48214","48215","48216","48217","48218","48219","48220","48221",
"48222","48223","48224","48225","48226","48227","48228","48229","48230","48231",
"48232","48233","48234","48235","48236","48237","48238","48239","48240","48242",
"48243","48244","48255","48260","48264","48265","48266","48267","48268","48269",
"48272","48275","48277","48278","48279","48288"
  ]
                },
        {
          "name": "Earl Blumenauer",
          "Office": "U.S. House-Oregon 3",
          "image": earl,
          "status": "Incumbent (did not seek re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Service Concluded — Retired",
          "zipCodes": []
        },
        {
          "name": "Buddy Carter",
          "Office": "U.S. House-Georgia 1",
          "image": buddy,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
          "zipCodes": [
    "30002","30004","30005","30008","30009","30011","30012","30013","30014","30016",
    "30017","30018","30019","30021","30022","30024","30025","30028","30030","30032",
    "30033","30034","30035","30038","30039","30040","30041","30043","30044","30045",
    "30046","30047","30052","30054","30055","30056","30058","30060","30062","30064",
    "30066","30067","30068","30070","30071","30072","30075","30076","30078","30079",
    "30080","30082","30083","30084","30087","30088","30090","30092","30093","30094",
    "30096","30097","30101","30102","30103","30104","30105","30106","30107","30108",
    "30110","30111","30113","30114","30115","30116","30117","30118","30120","30121",
    "30122","30124","30125","30126","30127","30132","30134","30135","30137","30139",
    "30141","30143","30144","30145","30147","30148","30149","30152","30153","30157",
    "30161","30165","30168","30170","30171","30173","30175","30176","30177","30178",
    "30179","30180","30182","30183","30184","30185","30187","30188","30189","30204",
    "30205","30206","30213","30214","30215","30216","30217","30218","30220","30222",
    "30223","30224","30228","30229","30230","30233","30234","30236","30238","30240",
    "30241","30248","30250","30251","30252","30253","30256","30257","30258","30259",
    "30260","30263","30265","30268","30269","30272","30273","30274","30275","30276",
    "30277","30281","30284","30285","30286","30288","30289","30290","30291","30292",
    "30293","30294","30295","30296","30297","30303","30305","30306","30307","30308",
    "30309","30310","30311","30312","30313","30314","30315","30316","30317","30318",
    "30319","30322","30324","30326","30327","30328","30329","30331","30332","30334",
    "30336","30337","30338","30339","30340","30341","30342","30344","30345","30346",
    "30349","30350","30354","30360","30363",
    "30401","30410","30411","30412","30413","30414","30415","30417","30420","30421",
    "30423","30425","30426","30427","30428","30434","30436","30439","30441","30442",
    "30445","30446","30448","30449","30450","30451","30452","30453","30454","30455",
    "30456","30457","30458","30460","30461","30464","30467","30470","30471","30473",
    "30474","30477","30478","30479",
    "30501","30502","30503","30504","30505","30506","30507","30508","30509","30510",
    "30511","30512","30513","30514","30515","30516","30517","30518","30519","30520",
    "30521","30522","30523","30524","30525","30527","30528","30529","30530","30531",
    "30533","30534","30535","30536","30537","30538","30539","30540","30541","30542",
    "30543","30545","30546","30547","30548","30549","30552","30553","30554","30555",
    "30557","30558","30559","30560","30562","30563","30564","30565","30566","30567",
    "30568","30571","30572","30573","30575","30576","30577","30578","30579",
    "30601","30602","30605","30606","30607","30609","30619","30620","30621","30622",
    "30623","30624","30625","30627","30628","30629","30630","30631","30633","30634",
    "30635","30639","30641","30642","30643","30646","30648","30650","30655","30656",
    "30660","30662","30663","30664","30665","30666","30667","30668","30669","30673",
    "30677","30678","30680","30683",
    "30701","30705","30707","30708","30710","30711","30720","30721","30724","30725",
    "30726","30728","30730","30731","30733","30734","30735","30736","30738","30739",
    "30740","30741","30742","30746","30747","30750","30751","30752","30753","30755",
    "30756","30757","30802","30803","30805","30807","30810","30812","30813","30814",
    "30815","30816","30817","30818","30820","30821","30822","30823","30824","30828",
    "30830","30833","30901","30904","30905","30906","30907","30909","30912",
    "31001","31002","31003","31004","31005","31006","31007","31008","31009","31011",
    "31012","31014","31015","31016","31017","31018","31019","31020","31021","31022",
    "31023","31024","31025","31027","31028","31029","31030","31031","31032","31033",
    "31034","31035","31036","31037","31038","31039","31041","31042","31044","31045",
    "31046","31047","31049","31050","31051","31052","31054","31055","31057","31058",
    "31060","31061","31062","31063","31064","31065","31066","31067","31068","31069",
    "31070","31071","31072","31075","31076","31077","31078","31079","31081","31082",
    "31083","31084","31085","31087","31088","31089","31090","31091","31092","31093",
    "31094","31096","31097","31098",
    "31201","31204","31206","31207","31210","31211","31213","31216","31217","31220",
    "31301","31302","31303","31305","31307","31308","31309","31312","31313","31314",
    "31315","31316","31318","31320","31321","31322","31323","31324","31326","31327",
    "31328","31329","31331","31333",
    "31401","31404","31405","31406","31407","31408","31409","31410","31411","31415",
    "31419","31421",
    "31501","31503","31510","31512","31513","31516","31518","31519","31520","31522",
    "31523","31524","31525","31527","31532","31533","31535","31537","31539","31542",
    "31543","31544","31545","31546","31547","31548","31549","31550","31551","31552",
    "31553","31554","31555","31556","31557","31558","31560","31561","31562","31563",
    "31564","31565","31566","31567","31568","31569","31599",
    "31601","31602","31605","31606","31620","31622","31623","31624","31625","31629",
    "31632","31635","31636","31637","31638","31639","31641","31642","31643","31645",
    "31647","31648","31649","31650",
    "31701","31704","31705","31707","31709","31712","31713","31714","31717","31719",
    "31720","31721","31722","31723","31724","31726","31727","31728","31730","31733",
    "31735","31738","31743","31744","31747","31749","31750","31753","31756","31757",
    "31763","31764","31765","31768","31771","31772","31773","31774","31775","31778",
    "31779","31780","31781","31783","31784","31787","31788","31789","31790","31791",
    "31792","31793","31794","31795","31796","31798",
    "31801","31803","31804","31805","31806","31807","31808","31810","31811","31812",
    "31814","31815","31816","31820","31821","31822","31823","31824","31825","31826",
    "31827","31829","31830","31831","31832","31833","31836",
    "31901","31903","31904","31905","31906","31907","31909"
  ]
        },
        {
          "name": "Judy Chu",
          "Office": "U.S. House-California 28",
          "image": judy,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
          "zipCodes": [
    "91001","91006","91007","91011","91016","91020","91024","91030",
    "91101","91103","91104","91105","91106","91107","91108","91125",
    "91214",
    "91701","91702","91711","91737","91739","91741","91750","91754","91755","91759",
    "91770","91775","91776","91780","91784",
    "91801","91803",
    "92358","92371","92397",
    "92407",
    "93543","93550","93553","93563"
  ]
        },
        {
          "name": "Steve Cohen",
          "Office": "U.S. House-Tennessee 9",
          "image": steve,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
          "zipCodes": [
    "91932",
    "92009","92014","92024","92025","92026","92027","92029","92037",
    "92064","92065","92067","92069","92075","92078","92084","92091","92092","92093","92096",
    "92101","92102","92103","92104","92105","92106","92107","92108","92109","92110",
    "92113","92116","92118","92121","92122","92127","92128","92129","92130","92132",
    "92134","92135","92140","92147","92155","92161"
  ]
        },
        {
          "name": "The Late Gerry Connolly",
          "Office": "U.S. House-Virginia 11",
          "image": gerry,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Service Concluded",
          "zipCodes": [
    "20120","20121","20124","20151","20170","20171","20190","20191","20194",
    "22003","22015","22027","22030","22031","22032","22033","22035","22039",
    "22066","22079",
    "22102","22124","22150","22151","22152","22153","22180","22181","22182",
    "22310","22315"
  ]
        },
        {
          "name": "Danny K. Davis",
          "Office": "U.S. House-Illinois 7",
          "image" : danny,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
          "zipCodes": []
        },
        {
          "name": "Lloyd Doggett",
          "Office": "U.S. House-Texas 37",
          "image": lloyd,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
          "zipCodes": [
    "78652","78701","78703","78704","78705","78712","78717","78722","78723","78726",
    "78727","78728","78729","78731","78732","78733","78739","78745","78746","78748",
    "78749","78750","78751","78752","78753","78756","78757","78758","78759"
  ]
        },
        {
          "name": "Glenn Ivey",
          "Office": "U.S. House-Maryland 4",
          "image": glenn,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
          "zipCodes": [
    "20705","20706","20707","20708","20710","20712","20720","20722","20735","20737",
    "20740","20742","20743","20744","20745","20746","20747","20748","20769","20770",
    "20771","20781","20782","20783","20784","20785",
    "20866","20868",
    "20904","20905","20912"
  ]
        },
        {
          "name": "Sheila Jackson Lee",
          "Office": "U.S. House-Texas 18",
          "image": sheila,
          "status": "Incumbent",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Deceased",
          "zipCodes": []
        },
        {
          "name": "Hank Johnson",
          "Office": "U.S. House-Georgia 4",
          "image": hank,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
          "zipCodes": [
    "30021","30032","30034","30035","30038","30044","30058","30071","30072","30083",
    "30084","30087","30088","30092","30093","30096","30097",
    "30319","30338","30340","30341","30345","30346",
    "30360"
  ]
        },
        {
          "name": "Marcy Kaptur",
          "Office": "U.S. House-Ohio 9",
          "image": marcy,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Service Concluded — Election Lost",
          "zipCodes": [
    "43406","43407","43408","43410","43412","43416","43420","43430","43431","43432",
    "43433","43434","43435","43436","43438","43439","43440","43442","43445","43446",
    "43447","43449","43452","43456","43457","43458","43460","43464","43465","43468",
    "43469","43501","43502","43504","43505","43506","43512","43515","43517","43518",
    "43519","43520","43521","43522","43526","43528","43530","43531","43533","43536",
    "43537","43540","43542","43543","43547","43548","43549","43551","43553","43554",
    "43556","43557","43558","43560","43566","43567","43570","43571",
    "43604","43605","43606","43607","43608","43609","43610","43611","43612","43613",
    "43614","43615","43616","43617","43619","43620","43623",
    "44089",
    "44811","44814","44824","44836","44839","44841","44846","44847","44870","44889"
  ]
        },
        {
          "name": "Raja Krishnamoorthi",
          "Office": "U.S. House-Illinois 8",
          "image": raja,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
          "zipCodes": []
        },
        {
          "name": "James McGovern",
          "Office": "U.S. House-Massachusetts 2",
          "image": james,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
          "zipCodes": [
    "01002","01003","01005","01012","01027","01031","01032","01035","01037","01038",
    "01039","01053","01054","01060","01062","01063","01066","01068","01072","01074",
    "01082","01084","01088","01093","01094","01096",
    "01301","01330","01331","01337","01338","01339","01340","01341","01342","01344",
    "01346","01347","01349","01351","01354","01355","01360","01364","01366","01368",
    "01370","01373","01375","01376","01378","01379","01380",
    "01436","01438","01452","01453","01468","01473",
    "01501","01505","01516","01519","01520","01522","01524","01525","01527","01532",
    "01534","01536","01541","01542","01543","01545","01560","01564","01568","01569",
    "01570","01581","01583","01588","01590",
    "01602","01603","01604","01605","01606","01607","01608","01609","01610","01611","01612",
    "01721","01745","01746","01748","01772",
    "02053"
  ]
        },
        {
          "name": "Jared Moskowitz",
          "Office": "U.S. House-Florida 23",
          "image": jared,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
          "zipCodes": [
    "33060","33062","33063","33064","33065","33066","33067","33069",
    "33071","33073","33076",
    "33301","33304","33305","33306","33308","33315","33316","33334",
    "33428","33431","33432","33433","33434","33441","33442",
    "33486","33487","33496","33498"
  ]
        },
        {
          "name": "Kevin Mullin",
          "Office": "U.S. House-California 15",
          "image": kevin,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
          "zipCodes": [
    "94002","94005","94010","94014","94015","94025","94030","94061","94063","94065",
    "94066","94070","94080",
    "94112","94128","94134",
    "94303",
    "94401","94402","94403","94404"
  ]
        },
        {
          "name": "Jerry Nadler",
          "Office": "U.S. House-New York 12",
          "image": jerry,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
          "zipCodes": []
        },
        {
          "name": "Joe Neguse",
          "Office": "U.S. House-Colorado 2",
          "image": joe,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
          "zipCodes": []
        },
        {
          "name": "Eleanor Holmes Norton",
          "Office": "Delegate to U.S. House-District of Columbia",
          "image": eleanor,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
          "zipCodes": []
        },
        {
          "name": "Frank Pallone",
          "Office": "U.S. House-New Jersey 6",
          "image": frank,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
          "zipCodes": [
    "07001","07008","07064","07067","07077","07080","07095",
    "07701","07703","07704","07711","07712","07716","07718","07720","07721","07723",
    "07730","07732","07734","07735","07737","07739","07740","07747","07750","07753",
    "07756","07757","07758","07760","07764",
    "08817","08820","08830","08832","08837","08840","08854","08859","08861","08863",
    "08872","08879",
    "08901","08904"
  ]
        },
        {
          "name": "Dutch Ruppersberger",
          "Office": "U.S. House-Maryland 2",
          "image": dutch,
          "status": "Incumbent (did not seek re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Service Concluded — Retired",
          "zipCodes": []
        },
        {
          "name": "Brad Schneider",
          "Office": "U.S. House-Illinois 10",
          "image": schneider,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
           "zipCodes": [
    "60002","60015","60020","60022","60030","60031","60034","60035","60040","60041",
    "60043","60044","60045","60046","60048","60050","60051","60060","60061","60062",
    "60064","60069","60071","60072","60073","60075","60081","60083","60085","60087",
    "60088","60089","60090","60091","60093","60096","60097","60098","60099"
  ]
        },
        {
          "name": "Brad Sherman",
          "Office": "U.S. House-California 32",
          "image": sherman,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
          "zipCodes": [
    "90024","90025","90046","90049","90069","90073","90077",
    "90210","90263","90265","90272","90290",
    "90402",
    "91301","91302","91303","91304","91306","91307","91311","91316",
    "91324","91325","91326","91330","91335","91343","91356","91364",
    "91367","91371",
    "91401","91403","91406","91411","91423","91436",
    "91602","91604"
  ]
        },
        {
          "name": "Shri Thanedar",
          "Office": "U.S. House-Michigan 13",
          "image": thanedarImg,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
          "zipCodes": [
    "48101","48122","48125","48146","48174","48180","48184","48192","48195",
    "48201","48202","48203","48204","48205","48206","48207","48208","48209",
    "48210","48211","48212","48213","48214","48215","48216","48217","48218",
    "48221","48224","48225","48229","48233","48234","48236","48238","48242",
    "48243"
  ]
        },
        {
          "name": "Ritchie Torres",
          "Office": "U.S. House-New York 15",
          "image": ritchie,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
          "zipCodes": [
    "10451","10452","10453","10454","10455","10456","10457","10458","10459",
    "10460","10461","10462","10463","10466","10467","10469","10470","10471"
  ]
        },
        {
          "name": "Juan Vargas",
          "Office": "U.S. House-California 52",
          "image": juan,
          "status": "Incumbent (re-election)",
          "Election Year": "2024",
          "Primary": "2024",
          "Result": "Currently Serving",
  "zipCodes": [
    "91902","91910","91911","91913","91914","91915","91932","91950",
    "92102","92104","92105","92113","92114","92115","92136","92139",
    "92154","92173","92179"
  ]
        }
      ]
    }
  ]
}






      

];

/* =========================
   CARD COMPONENT
========================= */
function CandidateCard({ candidate, onClick }) {
  return (
    <div className="card__collection">
      <div className="cards cards--two" onClick={() => onClick(candidate)}>
      {candidate.image ? (
  <>
    <img
      src={candidate.image}
      alt={candidate.name}
      className="img-responsive"
    />

    {/* ✅ ADD THIS HERE */}
    {candidate.Result?.toLowerCase().includes("currently") && (
      <div className="win-panel">
        <img src={winBadge} alt="Winner" />
      </div>
    )}
  </>
) : (
  <div className="img-responsive candidate-no-image">
    No Image
  </div>
)}
        
          

        {/* GOLD LINES */}
        <span className="line-left"></span>
        <span className="line-right"></span>

        {/* NAME */}
        <p>
  <span>{candidate.name}</span>
</p>

      </div>
    </div>
  );
}

function CandidateCard2({ candidate, onClick }) {
  return (
    <div className="candidate-card-shell">
      <div className="candidate-card" onClick={() => onClick(candidate)}>
      <div className="candidate-img-container">
  {candidate.image ? (
    <img src={candidate.image} alt={candidate.name} />
  ) : (
    <div className="candidate-placeholder">No Image</div>
  )}

  {/* ✅ ADD THIS BLOCK */}
    {candidate.Result === "Currently Serving" && (
    <div className="win-panel">
      <img src={winBadge} alt="Winner" />
    </div>
  )}

          {/* ✅ Overlay text */}
          <div className="candidate-overlay">
            <h3>{candidate.name}</h3>
            <p>{candidate.designation}</p>
          </div>

          {candidate.status && (
            <span className="candidate-status-badge">
              {candidate.status}
            </span>
          )}
        </div>

        <div className="candidate-card-details">
          <h2>{candidate.name}</h2>
          <p className="candidate-designation">{candidate.designation}</p>

          {candidate.city && (
            <p><strong>City:</strong> {candidate.city}</p>
          )}
          {candidate.county && (
            <p><strong>County:</strong> {candidate.county}</p>
          )}
          {candidate.state && (
            <p><strong>State:</strong> {candidate.state}</p>
          )}
          {candidate.zipCodes?.length > 0 && (
            <p><strong>ZIP Code:</strong> {candidate.zipCodes.join(", ")}</p>
          )}
        </div>
      </div>
    </div>
  );
}

/* =========================
   MODAL
========================= */
function CandidateModal({ data, onClose }) {
  const [showZipFlyer, setShowZipFlyer] = useState(false);
  if (!data) return null;

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalContainer" onClick={(e) => e.stopPropagation()}>
        
        {/* Close Button */}
        <button className="modalClose" onClick={onClose}>✕</button>

        {/* Image — full photo, never cropped */}
        <div className="modalImage">
          {data.image ? (
            <img
              src={data.image}
              alt={data.name}
              className="modal-portrait"
            />
          ) : (
            <div className="placeholder">No Image</div>
          )}
        </div>

        {/* Content */}
        {/* Content */}
<div className="modalContent">

  <h2>{data.name}</h2>

  

  

  <div className="modalDetails">

    <p>
      <strong>Office:</strong> {data.Office}
    </p>

    <p>
      <strong>Status:</strong> {data.status}
    </p>

    <p>
      <strong>Election Year:</strong> {data["Election Year"]}
    </p>

    <p>
      <strong>Primary:</strong> {data.Primary}
    </p>

    <p>
      <strong>Result:</strong> {data.Result}
    </p>

    {data.zipCodes?.length > 0 && (
      <div className="zipSection">
        <button
          className="zipButton"
          onClick={() => setShowZipFlyer(true)}
        >
          ZIP Codes
        </button>
      </div>
    )}

  </div>

</div>

      </div>
      {showZipFlyer && (
  <div
    className="zipFlyerOverlay"
    onClick={() => setShowZipFlyer(false)}
  >
    <div
      className="zipFlyer"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="zipFlyerClose"
        onClick={() => setShowZipFlyer(false)}
      >
        ×
      </button>

      <h2>ZIP Codes</h2>

      <div className="zipFlyerCodes">
        {data.zipCodes?.map((zip, idx) => (
          <div key={idx} className="zipCodeItem">
            {zip}
          </div>
        ))}
      </div>
    </div>
  </div>
)}
    </div>
  );
}
function MediaCarousel({ items = [], index, setIndex, setOpenImg }) {

  const goNext = () => {
    setIndex((prev) => (prev + 1) % items.length);
  };

  const goPrev = () => {
    setIndex((prev) => (prev - 1 + items.length) % items.length);
  };

  const getPosition = (i) => {
    if (i === index) return "active";
    if (i === (index - 1 + items.length) % items.length) return "left";
    if (i === (index + 1) % items.length) return "right";
    return "hidden";
  };

  return (
    <div className="adv-slider">
      <button className="adv-arrow left" onClick={goPrev}>&#10094;</button>
      <button className="adv-arrow right" onClick={goNext}>&#10095;</button>

      {items.map((item, i) => {
  const position = getPosition(i);

  return (
    <div
      key={i}
      className={`adv-slide ${position}`}
      onClick={() => {
        if (position === "active") {
          setOpenImg(item.image); // ✅ open modal
        } else {
          setIndex(i); // optional: click side slides to bring center
        }
      }}
    >
      <img src={item.image} alt={item.title} />
    </div>
  );
})}
    </div>
  );
}
const HBSJ_CAUCUS_SECTION = "HINDU BUDDHIST SIKH JAIN (HBSJ) CAUCUS MEMBERS";

function HinduVotersGuide() {
  const location = useLocation();
  const tabsRef = useRef([]);
  const sectionRefs = useRef({});
  useEffect(() => {
  if (!tabsRef.current.length) return;

  let maxWidth = 0;

  tabsRef.current.forEach((el) => {
    if (el) {
      maxWidth = Math.max(maxWidth, el.offsetWidth);
    }
  });

  tabsRef.current.forEach((el) => {
    if (el) {
      el.style.width = maxWidth + "px";
    }
  });
}, []);
  const { ref: contentRef, active: contentActive } = useInView({
    threshold: 0.2,
    rootMargin: "0px 0px -15% 0px",
  });
  const handleTabClick = (sectionName) => {
    setActiveTab((prev) =>
      prev === sectionName ? null : sectionName
    );

    setTimeout(() => {
      sectionRefs.current[sectionName]?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };
  // ✅ Content (no images, no video)
  useEffect(() => {
    if (location.hash !== "#hbsj-caucus-members") return;

    setActiveTab(HBSJ_CAUCUS_SECTION);

    setTimeout(() => {
      sectionRefs.current[HBSJ_CAUCUS_SECTION]?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  }, [location.hash]);

  const items = useMemo(
    () => [
      { key: "issues", label: "Issue summaries" },
      { key: "scorecards", label: "Candidate scorecards" },
      { key: "endorsements", label: "Endorsements by A4H" },
      { key: "deadlines", label: "Voting deadlines" },
      { key: "absentee", label: "Absentee & early voting information" },
      { key: "polling", label: "Polling location tools" },
      { key: "registration", label: "Registration portal by state" },
    ],
    []
  );

  const [activeTab, setActiveTab] = useState(null);
  
  const [selected, setSelected] = useState(null);
  const [index, setIndex] = useState(0);
  const [openImg, setOpenImg] = useState(null);
  const pressReleases = useMemo(() => [
    { title: "Vivek Ramaswamy", image: PressImg01 },
    { title: "Mike Lawler", image: PressImg02 },
    { title: "Senator Jim Risch", image: PressImg03 },
    { title: "Ethan Agarwal", image: PressImg04 },
    { title: "Jason Miyares", image: PressImg05 },
    { title: "Neil Khot", image: PressImg06 },
    { title: "Bruce Leon", image: PressImg07 },
    { title: "Randy Fine", image: PressImg08 },
    { title: "Jimmy Patronis", image: PressImg09 },
    { title: "Vin Kruttiventi", image: PressImg10 },
    { title: "Haley Stevens", image: PressImg11 },
    { title: "Jag Nagendra", image: PressImg12 },
    { title: "Chinmay Nagarkar", image: PressImg13 },
    { title: "Hon. Theresa Rich", image: PressImg14 },
    { title: "Aditya Ahlawat", image: PressImg15 },
    
    
    
    
    { title: "Geary Higgins", image: PressImg20 },
    { title: "Andrew Friedson", image: AndrewFriedson },
    { title: "Ashok Baddi", image: AshokBaddi },
    { title: "Bridget Watson", image: BridgetWatson },
    { title: "Dr. Anil Kumar", image: DrAnilKumar },
    { title: "Dr. Prabu Selvam", image: DrPrabuSelvam },
    { title: "Hon Lien", image: HonLien },
    { title: "Ilanit Eliaz", image: IlanitEliaz },
    { title: "Manisha Pathak", image: ManishaPathak },
    { title: "Michael Gates", image: MichaelGates },
    { title: "Rakesh Ramakrishnan", image: RakeshRamakrishnan },
    { title: "Rod Vilhauer", image: RodVilhauer },
    { title: "Santosh Rao", image: SantoshRao },
    { title: "Seema Kanani", image: SeemaKanani },
    { title: "Senator Michael Webber", image: SenatorMichaelWebber },
    { title: "Shri Thanedar", image: ShriThanedar },
    { title: "Steve Hilton", image: SteveHilton },
    { title: "Tom Kuhn", image: TomKuhn },
    { title: "Jenne Alderks", image: JenneAlderks },
    { title: "Gregory W. Meeks", image: GregoryMeeks },
    { title: "Kathy Watanabe", image: KathyWatanabe },
    { title: "Sonia Salwan", image: SoniaSalwan },
    { title: "Shivraj Singh", image: ShivrajSingh },
    { title: "Melinda Liu", image: MelindaLiu },
    { title: "gopal Krishan", image: gopalkrishan },
    { title: "jay Vaingankar", image: jayvaingankar2 },
    { title: "chirag R. Kathrani", image: chiragrkathrani2 },
    { title: "deepika Naharas", image: deepikanaharas },
    { title: "bill Huizenga", image: billhuizenga2 },
    { title: "kismat R. Kathrani", image: kismatrkathrani },
    { title: "prathia Sonavane", image: prathiasonavane },
    { title: "renu Malhotra", image: renumalhotra },
    { title: "murali Srinivasan", image: muralisrinivasan },
    { title: "rakhi Israni", image: rakhiisrani },
    { title: "vipin Sharma", image: vipinsharma },
    { title: "rish Rao", image: rishrao },
    { title: "Jenny Rae Le Roux", image: jennyraeleroux },
    { title: "Pia Dandiya", image: pia },
    { title: "Lynette Lee Eng", image: eng },
    { title: "Tracy Kosolcharoen", image: tracy },
    { title: "Gopal Kumarappan", image: gopal2 },
    { title: "Bill Chuan", image: bill },
    { title: "Carol Pefley", image: carol },
    { title: "Herb Morgan", image: herb },
    { title: "Liang Fang Chao", image: liang },
    { title: "Mike Rogers", image: mikerogers },
    { title: "Keith Parker", image: parker },
    { title: "Jeremy Moss", image: moss },
    { title: "Gloria Romero", image: gloria },
    { title: "brett martinez", image: brettmartinez2 },
    { title: "darshana patel", image: darshanapatel2 },
    { title: "josh hoover", image: joshhoover2 },
    { title: "julie testa", image: julietesta2 },
    { title: "jason crow", image: jasoncrow2 },
    { title: "jason lin", image: jasonlin2 },
    { title: "phil weiser", image: philweiser2 },
    { title: "fiona ma", image: fionama2 },
    { title: "paul sethy", image: paulsethy },
    { title: "danielle penman", image: daniellepenman },
    { title: "john lovick", image: johnlovick },
    { title: "shelley kloba", image: shelleyklock },
    { title: "davina duerr", image: davinaduerr },
    { title: "ron scolesdang", image: ronscoles },

  ], []);
  


  return (
    <>
      <style>{`
        *,
        *:before,
        *:after {
          box-sizing: border-box;
        }

        html, body {
          overflow-x: hidden;
          margin: 0;
          padding: 0;
        }

        .img-responsive {
          max-width: 100%;
          height: auto;
          display: block;
        }

        .block.color-scheme-4{
          padding-left: 0 !important;
          padding-right: 0 !important;
          overflow-x: hidden;
        }

        .hvg-content{
          opacity: 0;
          transform: translateY(18px);
          filter: blur(6px);
          transition: opacity 650ms ease, transform 650ms ease, filter 650ms ease;
        }
        .hvg-content.is-active{
          opacity: 1;
          transform: translateY(0);
          filter: blur(0);
        }

        .mt-4{ margin-top: 1.5rem !important; }
      

        .tab {
  padding: 22px 40px;
  border-radius: 999px;
  cursor: pointer;
  text-align: center;

  width: 100%;
  max-width: 700px;   /* bigger button width */
  min-width: 500px;

  white-space: normal;   /* allow text wrapping */

  background: linear-gradient(90deg, #ffb347, #ff5e62);

  border: 2px solid transparent;

  color: #fff;
  font-weight: 700;
  font-size: 20px;
  line-height: 1.4;

  box-shadow:
    0 0 10px rgba(255, 0, 150, 0.4),
    0 0 20px rgba(0, 200, 255, 0.3);

  transition: all 0.3s ease;
  position: relative;
}
  .tabs {
  display: flex;
  flex-direction: column;
  gap: 16px;

  width: 100%;
}
  .tab::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 999px;
  padding: 2px;

  background: linear-gradient(90deg, #ff00cc, #3333ff, #00ffcc);

  -webkit-mask: 
    linear-gradient(#000 0 0) content-box, 
    linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
}
  .tab:hover {
  box-shadow: 
    0 0 20px rgba(255, 140, 0, 0.8),
    0 0 30px rgba(255, 94, 98, 0.7);
}
    .tab.active {
  background: linear-gradient(90deg, #ffb347, #ff5e62); /* 🔥 orange → red */
  color: white;

  box-shadow: 
    0 0 15px rgba(255, 140, 0, 0.7),
    0 0 25px rgba(255, 94, 98, 0.6);
}
.tab-wrapper{
  display:flex;
  align-items:center;
  gap:14px;

  width: 100%;
}

.tab-icon{
  font-size: 22px;
  font-weight: bold;

  background: linear-gradient(180deg,#1d4f91,#0a2d62);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  text-shadow:
    0 1px 2px rgba(212,175,55,0.7),
    0 2px 6px rgba(0,0,0,0.2);

  margin-right: 10px;

  transform: translateY(-1px);

  transition: all 0.3s ease;
}

.tab-wrapper:hover .tab-icon{
  transform: translateX(4px);
}
        .grid {
  display: grid;

  /* EXACTLY 4 CARDS PER ROW */
  grid-template-columns: repeat(4, 240px);

  justify-content: center;

  gap: 48px;

  width: 100%;

  margin: 30px auto;
}
        .container {
  max-width: 1300px;
  margin: 0 auto;   /* centers whole content */
}
        .card__collection {
          position: relative;
          display: block;
          padding: 0;
          overflow: visible;
        }

        /* =========================
   CARD CONTAINER
========================= */

.cards {
  width: 240px;
  height: 340px;

  position: relative;
  overflow: hidden;
  cursor: pointer;

  border-radius: 16px;

  background: #071b3a;

  /* THIN GOLD BORDER */
  border: 5px solid #b39c18ff;

  box-shadow:
    0 8px 22px rgba(0,0,0,0.28),
    0 0 0 1px rgba(255,215,90,0.25),
    0 6px 14px rgba(212,175,55,0.18);

  transition:
    transform 0.45s ease,
    box-shadow 0.45s ease;
  transform-style: preserve-3d;
  perspective: 1200px;
} 

/* PREMIUM HOVER */
.cards:hover {
  transform: translateY(-5px);

  box-shadow:
    0 16px 34px rgba(0,0,0,0.32),
    0 0 0 1px rgba(255,215,90,0.45),
    0 10px 24px rgba(212,175,55,0.22);
}

/* =========================
   IMAGE
========================= */

.cards img,
.cards .candidate-no-image {
  width: 100%;
  height: 100%;

  object-fit: cover;
  object-position: center center;

  display: block;
}

        .candidate-no-image {
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #ececec, #d9d9d9);
          color: #666;
          font-size: 15px;
        }

        /* =========================
          cards--two exact-inspired
        ========================= */
        .cards--two {
  position: relative;
  overflow: hidden;
}
/* OPTIONAL small premium lift */
.cards--two:hover {
  transform: translateY(-4px);
  box-shadow: 0 22px 40px rgba(0,0,0,0.22);
}
        
 .cards--two p {
  position: absolute;

  left: 0;
  right: 0;
  bottom: 0;

  height: 60px;

  margin: 0;
  padding: 0 14px;

  display: flex;
  align-items: center;
  justify-content: center;

  text-align: center;

  color: #f2c94c;

  font-size: 17px;
  font-weight: 800;
  line-height: 1.15;

  z-index: 5;

  text-shadow:
    0 2px 4px rgba(0,0,0,0.45);
}

/* IMPORTANT */
.cards--two p span{
  display:block;
}

        

        .cards--two img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: none;
}
/* =========================
   BOTTOM BLUE PANEL
========================= */

.cards--two::after {
  content: "";

  position: absolute;

  left: 0;
  right: 0;
  bottom: 0;

  height: 78px;

  background: linear-gradient(
    to bottom,
    #0e3768 0%,
    #04152d 100%
  );

  

  z-index: 2;
}

/* =========================
   STAR + SEPARATOR
========================= */

/* STAR */
.cards--two::before {
  content: "★";

  position: absolute;

  left: 50%;
  bottom: 64px;

  transform: translateX(-50%);

  font-size: 24px;
  line-height: 1;

  color: #b39c18ff;

  z-index: 6;

  text-shadow:
    0 2px 4px rgba(0,0,0,0.35);
}

/* LEFT LINE */
.cards--two .line-left {
  position: absolute;

  left: 0;
  width: calc(50% - 20px);

  bottom: 74px;

  height: 5px;

  background: linear-gradient(
    to right,
    rgba(212,175,55,0.15),
    rgba(212,175,55,0.75)
  );

  z-index: 5;
}

/* RIGHT LINE */
.cards--two .line-right {
  position: absolute;

  right: 0;
  width: calc(50% - 20px);

  bottom: 74px;

  height: 5px;

  background: linear-gradient(
    to left,
    rgba(212,175,55,0.15),
    rgba(212,175,55,0.75)
  );

  z-index: 5;
}  
.candidate-status-badge {
  position: absolute;
  top: 10px;
  right: 10px;

  background: rgba(255,255,255,0.92);

  color: #0d2344;

  padding: 5px 10px;

  border-radius: 999px;

  font-size: 11px;
  font-weight: 700;

  z-index: 10;

  box-shadow:
    0 4px 12px rgba(0,0,0,0.18);
} 
   .cards {
  position: relative;
}

/* RIGHT SIDE PANEL */
.win-panel {
  position: fixed;
  top: 0;
  right: 0;

  width: 120px;   /* only small area */
  height: auto;

  z-index: 9999;
}
  /* WIN IMAGE */
.win-panel img {
  width: 100%;
  height: auto;
}

  
        .candidate-hover-details {
          position: absolute;
          inset: 0;
          z-index: 10;

          display: flex;
          flex-direction: column;
          justify-content: center;

          padding: 24px 20px;

          /* ✨ NO BLACK */
          background: rgba(255, 255, 255, 0.85); /* light glass */
          backdrop-filter: blur(8px);

          color: #111;

          opacity: 0;
          transition: all .3s ease;
          pointer-events: none;

          border-radius: 15px;
        }

        

        .candidate-hover-details h4 {
          margin: 0 0 8px;
          font-size: 22px;
          line-height: 1.2;
          font-weight: 800;
        }

        .candidate-hover-details .candidate-role {
          margin: 0 0 14px;
          font-size: 14px;
          color: #ffd86b;
          line-height: 1.45;
        }

        .candidate-hover-details p {
          margin: 6px 0;
          font-size: 13px;
          line-height: 1.55;
          color: #f3f4f6;
          word-break: break-word;
        }

        .candidate-hover-details strong {
          color: #fff;
        }

        .candidate-view-btn {
          margin-top: 16px;
          border: none;
          padding: 10px 16px;
          border-radius: 999px;
          background: #ffdb5e;
          color: #111;
          font-weight: 700;
          cursor: pointer;
          align-self: flex-start;
          box-shadow: 0 10px 24px rgba(255,219,94,0.22);
        }

        .candidate-view-btn:hover {
          transform: translateY(-1px);
        }
        .candidate-section {
  width: 100%;
  margin-bottom: 40px;
}

.candidate-group-title {
  text-align: center;
  font-size: 30px;
  font-weight: 800;
  color: #e55b2d;
  margin: 35px 0 20px;
  position: relative;
  text-transform: uppercase;
  letter-spacing: 2px;
}



.candidate-group-title::before {
  left: 25%;
}

.candidate-group-title::after {
  right: 25%;
}
.a4h-main-header {
  text-align: center;
  font-size: 48px;
  font-weight: 900;
  margin: -30px 0;
  color: #000;
  
}
.section-divider{
  width:100%;
  max-width:900px;
  margin:32px auto 38px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:3px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}
/* =========================
   RED GLOSSY TITLE BAR
========================= */

.title-bar{
  position: relative;

  width: 100%;
  max-width: 980px;

  margin: 40px auto 28px;

  height: 52px;

  border-radius: 999px;

  background:
    linear-gradient(
      to bottom,
      #ff5b6b 0%,
      #d70f2b 45%,
      #8b0000 100%
    );

  border: 3px solid #6e0000;

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow:
    inset 0 2px 0 rgba(255,255,255,0.45),
    inset 0 -3px 8px rgba(0,0,0,0.35),
    0 6px 16px rgba(0,0,0,0.25);
}

/* glossy shine */
.title-bar::before{
  content: "";

  position: absolute;

  top: 4px;
  left: 10px;
  right: 10px;

  height: 40%;

  border-radius: 999px;

  background: linear-gradient(
    to bottom,
    rgba(255,255,255,0.65),
    rgba(255,255,255,0.08)
  );
}

/* text */
.title-bar-text{
  position: relative;
  z-index: 2;

  color: white;

  font-size: 28px;
  font-weight: 900;

  letter-spacing: 2px;
  text-transform: uppercase;

  text-shadow:
    0 2px 4px rgba(0,0,0,0.4);
}
@keyframes dividerGlow{
  0%{ transform:scale(1); opacity:.8; }
  50%{ transform:scale(1.15); opacity:1; }
  100%{ transform:scale(1); opacity:.8; }
}
        /* ================= MODAL ================= */
        .modalOverlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.6);
          backdrop-filter: blur(8px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }

        .modalContainer {
          background: rgba(255,255,255,0.98);
          border-radius: 18px;
          width: min(920px, 94vw);
          max-width: 920px;
          max-height: 92vh;
          display: flex;
          flex-direction: row;
          align-items: stretch;
          position: relative;
          overflow: hidden;
          box-shadow: 0 30px 80px rgba(0,0,0,0.25);
        }

        .modalImage {
          flex: 0 0 46%;
          width: 46%;
          min-height: 320px;
          max-height: 92vh;
          background: #0e0e0e;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          padding: 16px;
        }

        .modalImage img,
        .modalImage img.modal-portrait,
        .modalContainer .modalImage img.modal-portrait {
          width: auto !important;
          height: auto !important;
          max-width: 100% !important;
          max-height: min(70vh, 520px) !important;
          min-width: 0 !important;
          min-height: 0 !important;
          object-fit: contain !important;
          object-position: center center !important;
          display: block !important;
          margin: 0 auto !important;
        }

        .modalImage .placeholder {
          color: #888;
          font-size: 15px;
          padding: 24px;
          text-align: center;
        }

        .modalContent {
          flex: 1 1 54%;
          padding: 28px 24px;
          text-align: left;
          overflow-y: auto;
          max-height: 92vh;
        }

        .modalContent h2 {
  text-align: center;
  margin-bottom: 28px;
  font-size: 42px;
  font-weight: 800;
  color: #3b0000;
  text-transform: capitalize;
}

.modalDetails {
  margin-top: 10px;
}
        .designation {
          font-size: 14px;
          color: #666;
          margin-bottom: 10px;
        }

        .modalStatus {
          display: inline-block;
          margin-bottom: 12px;
          font-size: 12px;
          font-weight: 700;
          color: #16a34a;
        }

        .description {
          font-size: 14px;
          line-height: 1.65;
          color: #333;
        }

        .modalClose {
          position: absolute;
          top: 10px;
          right: 12px;
          width: 34px;
          height: 34px;
          border: none;
          border-radius: 50%;
          background: white;
          cursor: pointer;
          font-size: 18px;
          z-index: 2;
          box-shadow: 0 6px 18px rgba(0,0,0,0.15);
        }

.adv-slider{
  position:relative;

  display:flex;
  flex-direction:column;   /* ✅ ADD THIS */
  align-items:center;
  justify-content:center;

  height:auto;             /* ✅ CHANGE */
  min-height:500px;

  perspective:1200px;
  margin:60px auto;
  max-width:1100px;
}

.adv-slider.expanded{
  height:900px;
}

.adv-slide{
  position:absolute;
  width:650px;
  height:420px;
  border-radius:12px;
  overflow:hidden;
  transition:all .6s ease;
  box-shadow:0 25px 50px rgba(0,0,0,0.4);
}

/* 👇 ADD THIS */
.adv-slider::after{
  content:"";
  display:block;
  height:460px; /* pushes content below slides */
}

.adv-slide.active{
  transform:translateX(0) scale(1);
  z-index:3;
  opacity:1;
}

.adv-slide.left{
  transform:translateX(-420px) scale(.8) rotateY(25deg);
  opacity:.6;
}

.adv-slide.right{
  transform:translateX(420px) scale(.8) rotateY(-25deg);
  opacity:.6;
}

.adv-slide.hidden{
  opacity:0;
  pointer-events:none;
}

.adv-slide img{
  width:100%;
  height:100%;
  object-fit:cover;
}

/* arrows */
.adv-arrow{
  position:absolute;
  top:50%;
  transform:translateY(-50%);

  width:70px;              /* bigger size */
  height:70px;
  border-radius:50%;

  border:none;
  font-size:32px;          /* bigger icon */
  font-weight:bold;

  background:rgba(255,255,255,0.9);
  backdrop-filter: blur(6px);

  box-shadow:0 10px 25px rgba(0,0,0,0.3);
  cursor:pointer;
  z-index:10;

  transition:all 0.3s ease;
}

/* spacing from slides */
.adv-arrow.left{ left:-60px; }
.adv-arrow.right{ right:-60px; }

/* hover effect */
.adv-arrow:hover{
  background:#ff8a00;
  color:white;
  transform:translateY(-50%) scale(1.1);
}

/* click effect */
.adv-arrow:active{
  transform:translateY(-50%) scale(0.95);
}

/* section */



.press-title{
  text-align:center;
  font-size:42px;
  font-weight:700;
  color:#090202ff;
  margin-top:10px;     /* 🔥 space above header */
  margin-bottom:-20px;  /* 🔥 space between header and slideshow buttons */
}


/* bottom info box */
.press-info{
  text-align:center;
  margin-top:80px; /* more spacing */

  display:flex;
  flex-direction:column;
  align-items:center;
}

/* 🔴 TITLE (NAME) */
.press-info h3{
  font-size:36px;         /* increased from 26px */
  font-weight:700;
  color:#003366;
  margin-bottom:25px;
  letter-spacing:1px;     /* cleaner look */
}

/* 🟠 BUTTON */
.press-info button{
  padding:16px 40px;      /* bigger button */
  border:none;
  border-radius:10px;     /* smoother corners */
  
  font-size:18px;         /* bigger text */
  font-weight:600;

  background:#ff8a00;
  color:white;

  cursor:pointer;
  transition:all 0.3s ease;
}

/* hover effect */
.press-info button:hover{
  background:#e67600;
  transform:translateY(-2px);
  box-shadow:0 10px 20px rgba(0,0,0,0.2);
}

/* click effect */
.press-info button:active{
  transform:scale(0.96);
}

/* fullscreen image */

.press-widget{
  position:fixed;
  inset:0;
  background:rgba(0,0,0,0.9);
  display:flex;
  align-items:center;
  justify-content:center;
  z-index:999999;
}

.press-widget-content{
  position:relative;
}

.press-widget-content img{
  max-width:90vw;
  max-height:90vh;
  object-fit:contain;
  border-radius:8px;
}

.press-widget-close{
  position:absolute;
  top:20px;
  right:20px;
  width:40px;
  height:40px;
  border:none;
  border-radius:50%;
  background:#666;
  color:#fff;
  font-size:22px;
  cursor:pointer;
}
.zipButton{
  background:#5a0000;
  color:#fff;
  border:none;
  padding:10px 18px;
  border-radius:8px;
  font-size:16px;
  font-weight:600;
  cursor:pointer;
  transition:0.3s;
}

.zipButton:hover{
  background:#8b0000;
  transform:scale(1.05);
}

.zipFlyerOverlay{
  position:fixed;
  inset:0;
  background:rgba(0,0,0,0.7);
  display:flex;
  align-items:center;
  justify-content:center;
  z-index:9999;
}

.zipFlyer{
  background:white;
  width:1100px;          /* increased width */
  max-width:95%;
  border-radius:18px;
  padding:35px;
  position:relative;
  animation:popup 0.3s ease;
}

.zipFlyer h2{
  text-align:center;
  margin-bottom:25px;
  color:#5a0000;
  font-size:32px;
  font-weight:700;
}

.zipFlyerCodes {
  display:grid;
  grid-template-columns:repeat(8, minmax(90px, 1fr));
  gap:12px;

  max-height:500px;
  overflow-y:auto;
  overflow-x:hidden;   /* removes horizontal scrollbar */

  padding-right:10px;
}
.zipFlyerCodes::-webkit-scrollbar {
  width: 8px;
}

.zipFlyerCodes::-webkit-scrollbar-thumb {
  background: #bbb;
  border-radius: 10px;
}

.zipFlyerCodes::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.zipCodeItem {
  background:#f3f3f3;
  padding:10px 12px;
  border-radius:10px;
  text-align:center;
  font-weight:600;
  font-size:15px;
  white-space:nowrap;
}



.zipFlyerClose{
  position:absolute;
  top:10px;
  right:15px;
  border:none;
  background:none;
  font-size:30px;
  cursor:pointer;
}

@keyframes popup{
  from{
    opacity:0;
    transform:scale(0.8);
  }
  to{
    opacity:1;
    transform:scale(1);
  }
}
        /* =========================
   MOBILE UI
========================= */
@media (max-width: 768px) {

  .block.color-scheme-4 {
    padding-top: 12px !important;
    padding-bottom: 24px !important;
  }

  .container {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 12px !important;
    margin: 0 auto !important;
  }

  .a4h-main-header {
    font-size: 22px !important;
    line-height: 1.25 !important;
    margin: 8px 0 0 !important;
    padding: 0 4px;
    text-align: center !important;
  }

  .section-divider {
    margin: 12px auto 16px !important;
    gap: 10px !important;
    max-width: 100% !important;
  }

  .section-divider span {
    font-size: 16px !important;
  }

  /* Tabs / accordion buttons */
  .tabs {
    width: 100% !important;
    gap: 10px !important;
    padding: 0 !important;
  }

  .tab-wrapper {
    width: 100% !important;
    gap: 8px !important;
    margin: 0 !important;
    padding: 0 !important;
    justify-content: center !important;
  }

  .tab-icon {
    display: none !important;
  }

  .tab {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    min-height: 44px !important;
    padding: 12px 14px !important;
    font-size: 13px !important;
    line-height: 1.3 !important;
    border-radius: 14px !important;
    white-space: normal !important;
    text-align: center !important;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
  }

  .tab::before {
    border-radius: 14px !important;
  }

  /* Section red title bars */
  .title-bar {
    width: calc(100% - 0px) !important;
    max-width: 100% !important;
    height: auto !important;
    min-height: 44px !important;
    margin: 18px auto 14px !important;
    padding: 10px 14px !important;
    border-radius: 14px !important;
    border-width: 2px !important;
  }

  .title-bar::before {
    border-radius: 12px !important;
  }

  .title-bar-text {
    font-size: 14px !important;
    line-height: 1.3 !important;
    letter-spacing: 0.5px !important;
    text-align: center !important;
    padding: 0 4px;
  }

  /* Candidate grid: 2 columns, fluid cards */
  .grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 12px !important;
    margin: 12px auto 20px !important;
    width: 100% !important;
    justify-content: stretch !important;
    padding: 0 !important;
  }

  .card__collection,
  .candidate-card-shell {
    width: 100% !important;
    max-width: 100% !important;
  }

  .cards,
  .cards--two,
  .candidate-card {
    width: 100% !important;
    max-width: 100% !important;
    height: 250px !important;
    min-height: 250px !important;
    border-width: 3px !important;
    border-radius: 12px !important;
  }

  /* Beat global mobile "img { width: auto }" so portraits fill the card */
  body main .cards img,
  body main .cards .candidate-no-image,
  body main .cards--two img,
  body main .candidate-card img,
  body main .candidate-img-container img,
  .cards img,
  .cards .candidate-no-image,
  .cards--two img,
  .candidate-image,
  .candidate-img-container img,
  .cards .img-responsive {
    width: 100% !important;
    max-width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    object-position: top center !important;
  }

  .candidate-no-image {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    background: #0d2344 !important;
    color: #fff !important;
    font-size: 12px !important;
  }

  .cards--two::after {
    height: 56px !important;
  }

  .cards--two::before {
    bottom: 44px !important;
    font-size: 18px !important;
  }

  .cards--two .line-left,
  .cards--two .line-right {
    bottom: 52px !important;
    height: 3px !important;
  }

  .cards--two p,
  .candidate-name,
  .candidate-overlay h4 {
    height: 48px !important;
    font-size: 12px !important;
    line-height: 1.2 !important;
    padding: 0 8px !important;
  }

  .candidate-designation,
  .candidate-office {
    font-size: 11px !important;
    line-height: 1.3 !important;
  }

  .candidate-card-details {
    padding: 8px 6px 10px !important;
  }

  .candidate-status-badge {
    font-size: 9px !important;
    padding: 3px 7px !important;
    top: 6px !important;
    right: 6px !important;
  }

  .win-panel {
    width: 56px !important;
  }

  /* Certificates / press section */
  .press-section {
    margin-top: 20px !important;
    padding: 0 0 20px !important;
    overflow: hidden !important;
  }

  .press-title {
    font-size: 20px !important;
    line-height: 1.3 !important;
    text-align: center !important;
    margin: 8px 0 14px !important;
    padding: 0 8px;
  }

  .adv-slider {
    width: 100% !important;
    max-width: 100% !important;
    min-height: 0 !important;
    height: auto !important;
    margin: 16px auto !important;
    perspective: none !important;
    overflow: hidden !important;
  }

  .adv-slider::after {
    height: 0 !important;
  }

  .adv-slide {
    position: relative !important;
    width: 92% !important;
    max-width: 360px !important;
    height: auto !important;
    aspect-ratio: 3 / 4;
    max-height: 420px;
    transform: none !important;
    opacity: 1 !important;
    margin: 0 auto !important;
    left: 0 !important;
    right: 0 !important;
  }

  .adv-slide.left,
  .adv-slide.right,
  .adv-slide.hidden {
    display: none !important;
  }

  .adv-slide.active {
    display: block !important;
    transform: none !important;
    opacity: 1 !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }

  .adv-slide img {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain !important;
    object-position: center center !important;
    background: transparent !important;
  }

  .adv-arrow {
    width: 36px !important;
    height: 36px !important;
    font-size: 18px !important;
    z-index: 5 !important;
  }

  .adv-arrow.left { left: 6px !important; }
  .adv-arrow.right { right: 6px !important; }

  .press-info {
    text-align: center !important;
    margin-top: 16px !important;
    padding: 0 8px 12px !important;
  }

  .press-info h3 {
    font-size: 15px !important;
    line-height: 1.35 !important;
    margin-bottom: 10px !important;
  }

  .press-info button {
    width: 100% !important;
    max-width: 280px;
    font-size: 14px !important;
    padding: 12px 16px !important;
    margin: 0 auto;
    display: inline-block;
  }

  /* Candidate modal */
  .modalOverlay {
    padding: 12px !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .modalContainer {
    width: 100% !important;
    max-width: 100% !important;
    max-height: 92vh !important;
    overflow-y: auto !important;
    flex-direction: column !important;
    border-radius: 14px !important;
  }

  .modalImage {
    flex: none !important;
    width: 100% !important;
    min-height: 200px !important;
    max-height: 45vh !important;
    height: auto !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    background: #0e0e0e !important;
    overflow: hidden !important;
    padding: 12px !important;
  }

  .modalImage img,
  .modalImage img.modal-portrait,
  .modalContainer .modalImage img.modal-portrait,
  body main .modalImage img.modal-portrait,
  body .modalImage img.modal-portrait {
    width: auto !important;
    height: auto !important;
    max-width: 100% !important;
    max-height: 40vh !important;
    min-width: 0 !important;
    min-height: 0 !important;
    object-fit: contain !important;
    object-position: center center !important;
    margin: 0 auto !important;
    display: block !important;
  }

  .modalContent {
    flex: 1 1 auto !important;
    width: 100% !important;
    padding: 16px !important;
    max-height: none !important;
    overflow: visible !important;
  }

  .modalContent {
    padding: 16px !important;
  }

  .modalContent h2 {
    font-size: 22px !important;
    margin-bottom: 12px !important;
  }

  .modalContent p,
  .description {
    font-size: 13px !important;
    line-height: 1.55 !important;
  }

  .modalClose {
    top: 8px !important;
    right: 8px !important;
  }

  /* ZIP flyer */
  .zipFlyerOverlay {
    padding: 12px !important;
  }

  .zipFlyer,
  .zipFlyerContent {
    width: 100% !important;
    max-width: 100% !important;
    max-height: 85vh !important;
    overflow-y: auto !important;
    padding: 16px !important;
  }

  .zipFlyerCodes {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 8px !important;
  }

  .zipCodeItem {
    font-size: 12px !important;
    padding: 8px 4px !important;
  }

  .zipButton {
    width: 100% !important;
    font-size: 14px !important;
  }

  /* Press image popup */
  .press-widget {
    padding: 12px !important;
  }

  .press-widget-content {
    width: 100% !important;
    max-width: 100% !important;
  }

  .press-widget-content img {
    max-height: 80vh !important;
    width: 100% !important;
    object-fit: contain !important;
  }
}

@media (max-width: 480px) {
  .a4h-main-header {
    font-size: 18px !important;
  }

  .tab {
    font-size: 12px !important;
    padding: 11px 12px !important;
  }

  .grid {
    gap: 10px !important;
  }

  .cards,
  .cards--two,
  .candidate-card {
    height: 220px !important;
    min-height: 220px !important;
  }

  .cards--two p {
    font-size: 11px !important;
  }

  .title-bar-text {
    font-size: 12px !important;
  }

  .press-title {
    font-size: 18px !important;
  }
}

      `}</style>

      <section>
        <div className="block color-scheme-4">
          {/* Heading + intro */}
          

          <div className="container">
            <h1 className="a4h-main-header">
              A4H ENDORSED CANDIDATES
            </h1>
          <div className="section-divider">
            <span>✦ ✦ ✦</span>
          </div>
            

          <div className="tabs">
  {DATA.map((section, index) => (
    <div
      key={section.name}
      id={section.name === HBSJ_CAUCUS_SECTION ? "hbsj-caucus-members" : undefined}
      ref={(el) => (sectionRefs.current[section.name] = el)}
    >

      {/* BUTTON + SYMBOL */}
      <div className="tab-wrapper">

        {/* LEFT SYMBOL */}
        <span className="tab-icon">⮞</span>

        {/* BUTTON */}
        <div
          ref={(el) => (tabsRef.current[index] = el)}
          className={`tab ${activeTab === section.name ? "active" : ""}`}
          onClick={() => handleTabClick(section.name)}
        >
          {section.name}
        </div>

      </div>

      {/* CONTENT BELOW CLICK */}
{activeTab === section.name && (
  <div>

    {/* MAIN CANDIDATES */}
    {section.candidates?.length > 0 && (
      <div className="grid">
        {section.candidates.map((c, i) => (
          <CandidateCard
            key={`main-${i}`}
            candidate={c}
            onClick={setSelected}
          />
        ))}
      </div>
    )}

    {/* SUBSECTIONS */}
    {section.subsections?.map((sub, i) => (
      <div key={i} className="candidate-section">

        {/* TITLE */}
        {/* RED BAR TITLE */}
        <div className="title-bar">
  <span className="title-bar-text">
    {sub.name}
  </span>
</div>

        {/* CARDS */}
        <div className="grid">
          {(sub.candidates || []).map((c, j) => (
            <CandidateCard
              key={`sub-${i}-${j}`}
              candidate={c}
              onClick={setSelected}
            />
          ))}
        </div>

      </div>
    ))}

  </div>
)}

        
    

    </div>
  ))}
  <div className="section-divider">
            <span>✦ ✦ ✦</span>
          </div>
</div>
<div className="press-section">

  <div className="container">
    <h1 className="press-title">Certificates of Endorsements by A4H</h1>
    <MediaCarousel 
  items={pressReleases} 
  index={index} 
  setIndex={setIndex} 
  setOpenImg={setOpenImg}
/>
<div className="press-info">
  <h3>{pressReleases[index].title}</h3>

  <button onClick={() => setOpenImg(pressReleases[index].image)}>
    View Press Release
  </button>
</div>
{openImg && (
  <div className="press-widget" onClick={() => setOpenImg(null)}>
    <div className="press-widget-content" onClick={(e) => e.stopPropagation()}>
      <button className="press-widget-close" onClick={() => setOpenImg(null)}>
        ×
      </button>
      <img src={openImg} alt="Press Release" />
    </div>
  </div>
)}
  </div>

</div>

            {/* MODAL */}
            
          </div>
          <CandidateModal data={selected} onClose={() => setSelected(null)} />
        </div>
      </section>
    </>
  );
}

export default HinduVotersGuide;
